<template>
  <div class="article-frame">
    <div ref="content" class="article-box article-box-bg">
      <img class="header-img" :src="$getThemeImagePath('useful_link/pc_banner_sport.jpeg')">
      <div class="content pos-relative">
        <go-to-top />
        <h1 class="main-title">
          スポーツベット利用規約
        </h1>
        <h2 class="update-time">
          最終更新日：2026年6月25日
        </h2>
        <ol class="terms-list">
          <li class="fs_5">
            はじめに
            <ul class="list-type-disc">
              これらのスポーツブック利用規約（以下、『利用規約』）は、勝Win（以下、『弊社』）が提供するスポーツベットのサービス（以下、『スポーツブック』）の利用に関する条件を定めるものとです。スポーツブックでベットを賭けることにより、お客様はさい利用規約を読み、理解し、同意したものとみなされます。
            </ul>
          </li>
          <li class="fs_5">
            ベットの成立・同意および取消し
            <ul class="list-type-disc">
              <li>
                ベットは、弊社のシステムにより正式に受領され、ベット履歴に反映された時点で成立したものとみなされます。
              </li>
              <li>
                お客様は、ベットを確定・送信することにより、本スポーツベッティング利用規約および弊社の一般利用規約に同意したものとみなされます。
              </li>
              <li>
                ベット確定前に、お客様は選択内容、オッズ、ベット額、ならびにマーケット条件を十分に確認する責任を負います。
              </li>
              <li>
                ベット成立後のキャンセルまたは内容変更は、原則として認められません。
              </li>
              <li>
                イベント開始後、または結果が既に判明していると弊社が判断する場合に行われたベットは、ライブベッティング対象でない限り無効とされる場合があります。
              </li>
              <li>
                弊社は、事前の通知なく、独自の裁量によりいかなるベットも拒否する権利を有します。
              </li>
              <li>
                明白なオッズの誤表示、不正アクセス、システム障害などの特別な事情が認められる場合、弊社は該当ベットを無効とすることができます。
              </li>
              <li>
                イベントが中断された場合、公式データに基づき、賭け伝票に記載されたマーケットが開始時間から12〜48時間以内に完了しなかった場合は、次のように取り扱われます。中断時点ですでに結果が確定している賭けについては、その時点の結果を基に精算されます。一方で、結果が確定していない賭けについてはすべて無効となり、賭け金は返金されます。なお、特定のスポーツにおいて別途ルールが定められている場合は、そのスポーツのルールが優先されます。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            ベットの受付時間
            <ul class="list-type-disc">
              <li>
                弊社は、各マーケットにおけるベットの受付を、イベント開始前または試合中に行います。受付可否および締切は、弊社システムの時間設定に基づき自動的に管理されます。
              </li>
              <li>
                プレマッチベットは、イベント開始予定時刻の直前までに行う必要があります。
              </li>
              <li>
                イベント開始後に行われたプレマッチベットは、原則として無効とされます。
              </li>
              <li>
                システム上の遅延や表示エラーにより、開始後でもベット可能な状態となっていた場合でも、弊社は該当ベットを無効にする権利を有します。
              </li>
              <li>
                ライブベットは、試合中に弊社が定めた時間・状況でのみ提供されます。
              </li>
              <li>
                得点、ペナルティ、交代などの重要な試合状況に応じて、オッズの一時停止（オッズ凍結）が行われる場合があります。
              </li>
              <li>
                凍結中に行われたベットは、弊社の判断により受付が拒否されるか、無効とされる場合があります。
              </li>
              <li>
                ベット受付時刻は、弊社サーバー上に記録されたタイムスタンプが正式なものとされます。
              </li>
              <li>
                お客様側の端末、ブラウザ、ネットワーク環境などによる遅延や誤差は考慮されません。
              </li>
              <li>
                ベットが正常に受付された場合は、当該ベット内容と受付時刻が「ベット履歴」画面に表示されます。
              </li>
              <li>
                表示されていない場合は、ベットが成立していないか、無効とされる可能性があります。
              </li>
              <li>
                弊社は、ベット受付に関するシステム障害や技術的エラーにより発生したいかなる損害についても責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            イベント日時、オッズ、結果および関連情報の取扱い
            <ul class="list-type-disc">
              <li>
                <span class="fw_bold">イベント日時および開始時間</span>
                <ul class="list-type-circle">
                  <li>
                    弊社が提供するすべてのスポーツベットイベントの日時・開始時間は、公式競技団体の発表、試合主催者、または弊社が信頼する第三者情報提供機関の情報に基づき表示されます。
                  </li>
                  <li>
                    イベントの日時・開始時間は予告なく変更されることがあり、その場合は弊社が適宜情報を更新しますが、お客様は変更に伴う損害や影響について弊社に責任を問えません。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">オッズの確定および変更</span>
                <ul class="list-type-circle">
                  <li>
                    オッズは弊社の裁量により、ベット受付時点で確定します。オッズは事前に公開される場合がありますが、最終的には賭けを受け付けた瞬間のオッズが適用されます。
                  </li>
                  <li>
                    技術的要因やシステムエラー、オッズの誤表記などが判明した場合、弊社は当該ベットの取消、修正、または無効化を行う権利を有します。
                  </li>
                  <li>
                    一部マーケットにおいては、ベット受け付け後でもオッズ変更が行われる場合がありますが、その詳細はマーケット説明に従います。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">試合結果および関連情報の決定</span>
                <ul class="list-type-circle">
                  <li>
                    試合の結果やスコア、統計データ、ペナルティ、延長戦の有無などは、弊社が採用する公式統計データ提供機関（例：Opta、Sportradarなど）またはその他信頼できる情報源のデータに基づき決定されます。
                  </li>
                  <li>
                    公式結果が訂正・変更された場合は、弊社は最新の公式情報を基にベットの結果を修正する場合があります。
                  </li>
                  <li>
                    結果の決定基準が不明確な場合や紛争が発生した場合は、弊社の裁定が最終的かつ決定的なものとします。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">イベントの中止、延期および無効化</span>
                <ul class="list-type-circle">
                  <li>
                    イベントが主催者側の都合や不可抗力により中止または延期された場合、当該イベントに関するベットは弊社が定めるルールに従い処理されます。
                  </li>
                  <li>
                    延期されたイベントは、原則として延期後の開催日で結果が決定されますが、弊社が別途指定する場合を除き、延期期間が一定期間（例：30日）を超えた場合はベットが無効となりベット額は返金されます。
                  </li>
                  <li>
                    不可抗力やルール違反等によりイベントが無効となった場合、該当するベットは無効となり、ベット額は返金されるものとします。
                  </li>
                </ul>
              </li>
              <li>
                <span class="fw_bold">情報の正確性および責任範囲</span>
                <ul class="list-type-circle">
                  <li>
                    弊社はイベント日時、オッズ、結果および関連情報の正確性の維持に対して最大限努力いたしますが、情報提供の遅延、誤差、誤表記等による損害について一切の責任を負いません。
                  </li>
                  <li>
                    お客様は提供される情報を自己の責任で利用し、弊社の情報に起因する損害に関して、いかなる請求も行わないことに同意します。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="fs_5">
            オッズ
            <ul class="list-type-disc">
              <li>
                表示されているオッズは常に変動しており、ベット確定時のオッズが適用されます。
              </li>
              <li>
                お客様は表示されているオッズの形式を十分理解した上でベットを賭けるものとします。
              </li>
              <li>
                オッズの変動や表記に起因する誤解やトラブルについて、弊社は一切責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            キャッシュアウト
            <ul class="list-type-disc">
              <li>
                弊社は、対象となるマーケットにおいてキャッシュアウト機能を提供する場合があります。
              </li>
              <li>
                キャッシュアウト額はリアルタイムで変動し、提示されている額は保証されません。
              </li>
              <li>
                一度確定されたキャッシュアウトは、いかなる理由でも取消不可とします。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            マルチベット
            <ul class="list-type-disc">
              <li>
                すべての選択肢（セレクション）が的中した場合に限り、マルチベットは成立し、配当が支払われます。
              </li>
              <li>
                1つでも選択肢が不的中となった場合、そのマルチベットは失効となります。
              </li>
              <li>
                オッズは各選択肢の単独オッズを掛け合わせた合算オッズで計算されます。
              </li>
              <li>
                マルチベット内のすべての選択肢は、弊社が提供する合法的なマーケットからのものである必要があります。
              </li>
              <li>
                ベット受付締切時間は、マルチベット内の最後に締切となる個別ベットの受付時間に準じます。
              </li>
              <li>
                マルチベットに含まれる個別ベットの結果確定に遅延や変更が生じた場合、弊社は状況に応じて該当マルチベットの処理方法を決定します。
              </li>
              <li>
                特定のプロモーションやキャンペーンによっては、マルチベットに対する追加条件や制限が適用される場合があります。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            スポーツ毎のベットルール
            <ul class="list-type-disc">
              <li>
                <span class="fw_bold">サッカー</span>
                <ol class="list-inside pb_5">
                  1.1サッカーに対するベットは、特に明記されていない限り、前後半90分間（アディショナルタイム含む）終了時点の公式結果に基づいて精算されます。延長戦およびPK戦の結果は対象外となります。
                  <br>
                  <br>
                  1.2 会場が変更された場合でも、ホーム・アウェイのチームが変わらない限り、すべてのベットは有効です。ホーム/アウェイが逆転した場合は、すべてのベットが無効となります。
                  <br>
                  <br>
                  1.3 試合形式（試合時間の短縮、選手数の変更等）やルールがFIFAの規定と異なる場合、弊社は裁量によりベットを無効にする、または新しい条件に基づいて精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">野球</span>
                <ol class="list-inside pb_5">
                  1.1 野球に関するベットは、特に明記されていない限り、規定イニング終了時点（通常9回、延長がない場合は規定回の終了）の公式結果に基づいて精算されます。プロ野球の公式スコアに準拠します。
                  <br>
                  <br>
                  1.2 会場や対戦カードの変更が生じても、試合形式（例：5回制など特殊試合を除く）および対戦チームが同じであればベットは有効です。
                  <br>
                  <br>
                  1.3 試合形式（例：7回戦、マッスルカー規定の短縮試合等）が標準と異なる場合、マーケットへの明記がなければ弊社はベットを無効または裁量精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">バスケットボール</span>
                <ol class="list-inside pb_5">
                  1.1 すべてのベットは、試合終了時点（規定の試合時間 + 延長戦を含む）の公式結果に基づいて精算されます。延長戦で決着がついた場合でも、マネーライン、ハンディキャップ、トータルポイント等のマーケットは延長を含んだ最終スコアを用いて精算されます。
                  <br>
                  <br>
                  1.2 会場が変更された場合、ホームチームとアウェイチームの公式指定が維持されていれば、すべてのベットは有効とされます。役割が反転した場合、該当する試合に関連するベットは無効となります。
                  <br>
                  <br>
                  1.3 非公式試合（エキシビション、チャリティーマッチ、短縮試合等）は、事前にマーケットにその旨が明記されていない限り、弊社はベットを無効とする権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">バスケットボール（3×3）</span>
                <ol class="list-inside pb_5">
                  1.1 3x3バスケットボールに対するベットは、特に明記されていない限り、規定の試合時間（10分間）または21点先取の時点での公式結果に基づいて精算されます。延長戦（オーバータイム）が実施された場合、その得点も含まれます。
                  <br>
                  <br>
                  1.2 会場が変更された場合でも、チーム構成および試合形式（3対3）に変更がない限り、すべてのベットは有効です。会場条件により競技形式が異なると判断された場合、ベットは無効とされることがあります。
                  <br>
                  <br>
                  1.3 試合形式（得点制限の解除、延長ルールの変更等）や出場人数がFIBA 3x3の公式ルールと異なる場合、弊社は裁量によりベットを無効にする、または新しい条件に基づいて精算する権利を有します。
                </ol>
              </li>
              <li>
                <span class="fw_bold">テニス</span>
                <ol class="list-inside pb_5">
                  1.1 テニスに対するベットは、特に明記されていない限り、試合の最終結果（試合の勝敗）に基づいて精算されます。ATP、WTA、ITF、グランドスラムなどの公式結果が基準となります。
                  <br>
                  <br>
                  1.2 会場やコートサーフェス（例：クレーからハード）などの変更があった場合でも、対戦カードが同一であればベットは有効です。ただし、別大会または非公式イベントへの代替が行われた場合は無効となります。
                  <br>
                  <br>
                  1.3 試合形式（ベスト・オブ・3セットまたは5セット）に関して、マーケット名に明示されていない限り、どちらの形式でもベットは有効とされます。試合がスーパータイブレーク方式で代替される場合も同様です。弊社は必要に応じてベットを無効にする権利を有します。
                </ol>
              </li>
            </ul>
          </li>
          <li class="fs_5">
            最大払い戻し額
            <ul class="list-type-disc">
              <li>
                弊社が提供するスポーツベットにおける1ベットあたりの最大払い戻し額は、マーケットの種類、スポーツ種目、オッズの種類、またはイベントの重要性に応じて弊社が定める上限に制限されます。
              </li>
              <li>
                同一お客様（またはグループを含む）が同一内容のベットを複数回に分けて行った場合、該当するベットを1つのベットとみなすことができるものとし、その場合の払い戻しの上限も合算ベースで適用されます。
              </li>
              <li>
                弊社は必要に応じて最大払い戻し額の上限を変更、制限、または特定マーケットに適用される制限を事前の通知なく導入する権利を有します。
              </li>
              <li>
                払い戻し金額の計算において、弊社システムのエラーや不正確なオッズ適用により上限を超える金額が表示された場合でも、実際の払い戻し額は上記制限の範囲内に調整されます。
              </li>
              <li>
                お客様は、上記の最大払い戻し額が自らのベットに適用されることを理解するものとします。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            情報の正確性
            <ul class="list-type-disc">
              <li>
                弊社が提供するスコア、試合状況、統計等は参考情報であり、公式結果とは異なる可能性があります。
              </li>
              <li>
                ベットの最終的な精算は、公式競技運営機関または統括団体の発表に基づいて行われます。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            不正行為およびベッティングの誠実性
            <ul class="list-type-disc">
              <li>
                お客様は、すべてのベットを誠実かつ正当な意図に基づいて行うものとし、スポーツイベントの操作、八百長、不正確な情報に基づく賭け、または内部情報の不正利用を含むあらゆる不正行為に関与してはなりません。
              </li>
              <li>
                弊社は、以下のいずれかに該当するベットについて、受付の拒否、無効化、または一方的なキャンセルを行う権利を有します：
                <ul class="list-type-circle">
                  <li>
                    試合の結果が操作された、またはその可能性が高いと判断される場合
                  </li>
                  <li>
                    お客様がチーム、選手、審判、または関係者と不適切な関係にあると判明した場合
                  </li>
                  <li>
                    同一イベントに対して、明らかに統制されたグループによる大量かつ同一傾向のベットが確認された場合
                  </li>
                  <li>
                    ベットが、規制当局、スポーツ統括団体、または不正監視機関（例：Sportradar）からの警告対象となった場合
                  </li>
                </ul>
              </li>
              <li>
                弊社は、必要に応じて該当ユーザーのベット履歴およびアカウントを調査し、適切な措置（アカウント凍結、関係当局への通報等）を講じることができます。弊社は、不正行為の疑いにより発生したいかなる損害や逸失利益についても責任を負いません。
              </li>
            </ul>
          </li>
          <li class="fs_5">
            一般規約の適用
            <ul class="list-type-disc">
              <li>
                本スポーツベット利用規約は、弊社が別途定める一般利用規約とあわせて適用されます。
              </li>
              <li>
                特に明記されていない限り、以下の項目に関する規定は、一般利用規約の内容がそのまま本規約にも適用されるものとします：
                <ul class="list-type-circle">
                  <li>
                    アカウントおよび個人情報の取扱い
                  </li>
                  <li>
                    準拠法および裁判管轄
                  </li>
                  <li>
                    規約の改定・変更手続き
                  </li>
                  <li>
                    通知方法および言語
                  </li>
                  <li>
                    責任の制限および免責事項
                  </li>
                  <li>
                    知的財産権およびコンテンツの使用条件
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ol>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
    <hr style="margin:40px 0;border:0;border-top:1px solid #ddd;">
    <section id="ap-sports-rules" class="ap-sports-rules">
      <h1 class="main-title">
        APスポーツ ベットルール
      </h1>
      <div style="background:#fff8e5;border:1px solid #f0d78a;padding:15px;margin-bottom:20px;">
        <p>以下の規則は、APスポーツにおけるベット、精算、取消、延期・中止、会場変更および異常時の取扱いに適用されます。</p>
        <p>APスポーツに関する事項については、本項「APスポーツ ベットルール」が優先して適用されます。本ページ上部のスポーツベット利用規約は、APスポーツ規則に定めのない事項に補充的に適用されます。</p>
        <p>本項目はAP Gaming公式規則を基に、会員が確認しやすい順序で整理したものです。掲載順はAP Gaming公式ページと異なる場合がありますが、各項目の内容はAP Gaming公式規則に基づきます。</p>
        <p>AP Gaming側で規則更新があった場合、最新規則および実際の精算結果に基づいて処理される場合があります。</p>
      </div>
      <div id="ap-sports-rule-index" class="half list">
        <div style="background:#eee;margin-bottom:16px;">
          <table class="betting-rules" style="border-collapse:collapse;width:100%;" border="1">
            <tbody>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#General-Rules">全般ルール</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Teasers-Rules">ティーザールール</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Glossary">用語集</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Soccer">サッカー</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Baseball">野球</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Basketball">バスケットボール</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Volleyball">バレーボール</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Golf">ゴルフ</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Tennis">テニス</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Table-Tennis">卓球</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Badminton">バドミントン</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Snooker">スヌーカー</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Rugby">ラグビー</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#American-Football">アメリカンフットボール</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Aussie-Rules">オージールール</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Futsal">フットサル</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Cricket">クリケット</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Curling">カーリング</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Cycling">自転車競技</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Darts">ダーツ</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Squash">スカッシュ</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Athletics">陸上競技</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Auto-Racing">オートレーシング</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Handball">ハンドボール</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Water-Polo">水球</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Bandy">バンディ</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Hockey">ホッケー</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Winter-Sports">ウインタースポーツ</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Olympics">オリンピック</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Padel-Tennis">パデルテニス</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Boxing">ボクシングおよびMMA</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Politics">政治</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Esports-Rules">eスポーツ</a>
                </td>
              </tr>
              <tr>
                <td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
                  <a class="title" href="#Poker">ポーカー</a>
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
&nbsp;
                </td><td style="height:24px;padding:6px 10px;border:1px solid #ddd;">
&nbsp;
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="General-Rules" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          全般ルール
        </h3>
        <ol>
          <li>
            <p>チーム名またはベットの説明の英語版と他言語版との間で相違がある場合、英語版が正しいとみなされます。ベットの判定および紛争は、英語版のチーム名およびベットの説明に基づいて対処・解決されます。</p>
          </li>
          <li>
            <p>当社は、ラインの投稿で間違いがないよう確認するためにあらゆる努力をします。ただし、人為的エラーまたはシステムの問題の結果として、ベットが行われた時点で一般的な市場で利用できるオッズとは明確に異なる、またはベットが行われた時点で発生したイベントのチャンスを考慮すると明確に正しくないオッズでベットが受け付けられた場合、当社はその賭けをキャンセルまたは無効にするか、あるイベントが開始した後に行われた賭けをキャンセルまたは無効にしてプレイヤーに返金する権利を留保します。</p>
          </li>
          <li>
            <p>AP Gamingは、第三者から提供されるスコアボードを介してベッターにライブマッチ情報を表示することを目指しています。AP Gamingは、このスコアカードに表示される情報の正確性を保証できません。スコアカードに不正確なスコアまたはスタッツが表示されたとしても、それはベットが無効になる理由にはなりません。インプレイベットは、ベットを行う際にマーケットオファリングおよび/またはベットスリップに表示されるスコア、コーナー、またはブッキング情報を使用して行われます。これらの場所に不正確な情報が表示された場合のみ、ベットが無効になる理由になります。</p>
          </li>
          <li>
            <p>掲載されている試合カードの日時は、あくまで情報提供にすぎません。AP Gamingでは情報の正確性を保証することはできません。日付および/または時刻が誤って掲載されている場合でも、ベットが無効になることはありません。</p>
          </li>
          <li>
            <p>試合が開始し公式の開始予定時刻から30時間以内に完了しない場合、その試合のすべてのベットは無効になります。このルールの例外は次の通りです。</p>
            <ol style="list-style-type: upper-roman;">
              <li>
                <p>最後までプレイされたピリオド</p>
              </li>
              <li>
                <p>ゴルフトーナメントなど、通常の進行でも30時間を超える可能性のある試合カードの場合。</p>
              </li>
              <li>
                <p>各競技のルールセクションにその競技固有の例外が記載されている場合。</p>
              </li>
              <li>
                <p>「最初に得点したチーム」のベットは、試合カードが完了したかどうかにかかわらず、得点するとすぐにアクションになります。</p>
              </li>
            </ol>
          </li>
          <li>
            <p>試合が開始予定時刻から12時間以内に開始しない場合、その試合のすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>試合カードの結果は、試合カードの完了日に、試合カードの運営組織によって最終決定されます。AP Gamingでは、異議が申し立てられた、または覆された決定を受け入れません。競技開始後に中断された試合カードに対するベットの結果は、その競技で定められたベッティングルールに基づき決定されます。競技のルールで指定されていない場合は、全般ルール#7が適用されます。</p>
          </li>
          <li>
            <p>特定の競技ルールで明記されていない限り、会場が変更された場合、試合カードに対するすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>特定ピリオドのベットは、そのピリオド中のスコアリングのみをカウントし、前後のピリオドでの影響を受けません。何らかの理由で試合カードがAP Gamingのルールで定められた時間内に完了しない場合、試合カード全体へのベットが無効になります。完了したピリオドはアクションになります。</p>
          </li>
          <li>
            <p>マネーラインマーケットで「ドロー」プライスが提供され、ドローが発生した場合、各チームへのベットは負けとなります。ドローが提供されない場合にドローが発生したときは、両チームへのベットは無効になります。</p>
          </li>
          <li>
            <p>没収、不戦勝、またはその他の理由によりプレイせずに完了したとみなされる試合カードでは、そのリーグの運営組織の得点方法にかかわらず、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p>試合カードのラウンド数またはピリオド数が間違って提供された場合、またはその競技において非標準的な期間で提供され、そのことが示されていない場合、その試合カードのすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>スペルミス、誤植、チームの名称変更、リーグの名称の誤表示は、目的の試合カードが何であるかという点が明確である限り、ベットを無効とする理由にはなりません。</p>
          </li>
          <li>
            <p>試合カードのラウンド数またはピリオド数が間違って提供された場合、またはその競技において非標準的な期間で提供され、そのことが示されていない場合、その試合カードのすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>ある日(アメリカンフットボールの場合は週)のリーグのホーム/アウェイスコア集計マーケットの場合、その日/週のすべての試合カードが完了までプレイされなかった場合、そのマーケットのすべてのベットは無効です。</p>
          </li>
          <li>
            <p>マルチウェイベッティングは「オールイン」であり、特定の競技者が開始しなければアクションにならないという条件がマーケットに追加されていない限り、ベットは常にアクションです。こうした条件が加えられている場合、その特定のイベントで所定の競技者が開始しなければ、すべての競技者のすべてのベットが無効となります。</p>
          </li>
          <li>
            <p>マルチウェイマーケットでのすべての勝利ベットは、勝者の数にかかわらずフルオッズで支払われます。</p>
          </li>
          <li>
            <p>マーケットにベッティングオプションとして「フィールド」がある場合、指定されたチームまたは競技者が他のすべての競技者を倒せば、その競技者へのベットは勝利になります。指定された競技者がタイで勝利した場合、タイとなった競技者へのベットは無効となり、その他すべてのベットが負けとなります。</p>
          </li>
          <li>
            <p>確定したすべてのマーケットは、72時間が経過した後は最終とみなされ、その後の問い合わせは受け付けられません。マーケットが確定してから72時間以内の場合に限り、AP Gaming は、人的ミス、システムエラー、または結果の参照先ミスのために、結果のリセットまたは修正を行います。</p>
          </li>
          <li>
            <p>AP Gamingは、ベットが不正な方法で行われたとみなした場合、いつでもベットを無効にする権利を保有します。</p>
          </li>
          <li>
            <p>すべてのベットは、あくまでAP Gamingの裁量により受理、または拒否されます。インプレイベットは、受理される前に多少の遅延が発生する場合があり、および/または危険な状況では、AP Gamingの裁量で保留になる場合があります。</p>
          </li>
          <li>
            <p>マーケットのオッズまたは上限に明らかなエラーがある場合、そのマーケットのベットは無効になる場合があります。何らかの理由で、試合が開始した後にベットが受理された場合(試合中のライブベッティングと明確に記載がある場合を除く)、大きく有利になっていない限りベットは有効となります。有利になったと判断された場合、AP Gamingはそのベットを無効とする権利を有します。</p>
          </li>
          <li>
            <p>マルチプルベットの1暦日あたりの最大累計賞金は$250,000です。</p>
          </li>
          <li>
            <p>矛盾がある場合：マーケットルールは、スポーツルールよりも優先され、スポーツルールは全般ルールよりも優先されます。</p>
          </li>
          <li>
            <p>何らかの理由により、イベントの完了後72時間以内に会社が結果を有効とすることができない場合、そのイベントに関連するマーケットで確定していないすべてのベットは無効となります。</p>
          </li>
          <li>
            <p>AP Gamingは、Webサイトからイベント、マーケット、およびその他の商品を削除する権利を有します。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Teasers-Rules" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ティーザールール
        </h3>
        <ol>
          <li>
            <p>ティーザーはマルチプルベットで、ベッターには各選択肢でより有利なハンディキャップまたはトータルが与えられますが、ベットで勝つには各選択肢で勝たなければなりません。</p>
          </li>
          <li>
            <p>ティーザーのペイアウトはスポーツの種類、リーグ、選択肢の数、そしてポイントスプレッドの調整の大きさによって決まります。ティーザーのペイアウトについては、下の表をご参照ください。</p>
          </li>
          <li>
            <p><strong>標準のティーザー</strong>では、1つの選択肢がタイ(引き分け)または何らかの理由で無効となり、それ以外の選択肢が勝ちとなった場合、タイまたは無効となった選択肢は削除され、調整後の選択肢の数に基づいてペイアウトが決定します。タイまたは無効となった選択肢がすべて削除された後に、残った選択肢が1つしかなかった場合、そのティーザーすべてが無効となります。</p>
          </li>
          <li>
            <p>2つの選択肢のティーザーのうち1つの選択肢がタイまたは何らかの理由で無効になった場合、そのティーザーすべてが無効となります。</p>
          </li>
          <li>
            <p><strong>スーパーティーザー</strong>では、1つ以上の選択肢がタイまたは何らかの理由で無効になった場合、そのスーパーティーザーすべてが無効となります。</p>
          </li>
          <li>
            <p>AP Gamingは、すべてのティーザーに使用されるベースハンディキャップのバリューを決める権利を有します。</p>
          </li>
          <li>
            <p>ハンディキャップとトータルの大きさの違いが28未満であるすべてのNCAAフットボールの同じ試合のティーザーは、相関関係の理由からキャンセルされます。</p>
          </li>
        </ol>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="4">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  標準のバスケットボール
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                カレッジとWNBA
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                NBAサイド
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5.5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                NBAトータル
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7.5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2つの選択肢
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                3つの選択肢
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.8
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.6
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.5
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                4つの選択肢
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                5つの選択肢
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4.5
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                6つの選択肢
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                8
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="5">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  カレッジフットボールのみ
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7.5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.77
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                3チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.8
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.6
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                4チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                5チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                6チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                8
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="5">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  カレッジフットボール同ゲーム
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7.5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.05
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="4">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  標準のフットボール - NFLまたはNFLとカレッジ
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.77
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                3チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.6
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.4
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.2
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                4チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3.6
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3.4
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                5チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5.5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                5
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4.5
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                6チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                8
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="4">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  NFL同ゲーム
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                6.5ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="2">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  アリーナフットボール
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                7.5ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.91
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="3">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  フットボールスーパーティーザー
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                10ポイント
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                13ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                3チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.77
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                4チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                -
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.71
              </td>
            </tr>
          </tbody>
        </table>
        <p>&nbsp;</p>
        <table style="font-size: 0.9rem; border: 1px solid #dedede; background: #eee;">
          <tbody>
            <tr>
              <td style="border: 0;" colspan="2">
                <p style="font-weight: bold; margin: 1.3rem 1.3rem 1.3rem;">
                  NBAスーパーティーザー
                </p>
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
&nbsp;
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                サイドに7ポイントおよびトータルに9ポイント
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                2チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.5
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                3チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                1.83
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                4チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                2.4
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                5チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                3
              </td>
            </tr>
            <tr>
              <td style="text-align: left; border: 0; padding: 20px 0 20px 20px;">
                6チーム
              </td>
              <td style="text-align: left; border: 0; padding: 20px 0;">
                4
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Glossary" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          用語集
        </h3>
        <p><strong>試合カード：</strong>ベットが行われるイベント、競技、試合。</p>
        <p><strong>ピリオド：</strong> 試合カードの規定された部分。</p>
        <p><strong>競技者：</strong> 試合カードに参加する個人。</p>
        <p><strong>確定：</strong> ベットの確定。この時点でマーケットの結果に基づいてペイアウトが行われます。</p>
        <p><strong>結果：</strong>マーケットの結果。</p>
        <p><strong>アクション：</strong>ベットはその要件を満たす限り「アクション」です。アクションとは、ベットが最終結果で確定されることを意味します。</p>
        <p><strong>無効：</strong>何らかの理由でベットを返金します。最も一般的なのは、マーケットについての違法な何かにより、ベットを決定できない場合です。マーケットが無効な場合、そのマーケットのすべてのベットが無効になります。</p>
        <p><strong>完了：</strong>確定できる、有効な最終結果を持つマーケット。</p>
        <p><strong>カウント：</strong>マーケットのコンテキストで有効とみなされるスコアリングイベント。</p>
        <p><strong>マルチウェイ：</strong>3人以上の参加者が競技するマーケット。</p>
        <p><strong>インプレイ：</strong>いったん競技が始まると、マーケットは「インプレイ」とみなされます。</p>
        <p><strong>マーケット：</strong>試合カードのオファリング。</p>
        <p><strong>ベット：</strong>イベントまたはイベントの組み合わせの結果に対して、規定されたペイアウトを伴うリスクのあるステーク。</p>
        <p><strong>マルチプル：</strong>マルチプルオッズを組み合わせたベット。</p>
        <p><strong id="Teaser">ティーザー：</strong>固定オッズと調整されたハンディキャップまたはトータルを組み合わせたベット。</p>
        <p><strong>最終決定：</strong>そのピリオドで他に何が起きても影響しない、勝者が決定済みのマーケット。</p>
        <p><strong>スコアリング単位：</strong>マーケットの結果を決定するために使用されるスコアリングの単位。例えば、サッカーの試合では、ゴール、コーナーキック、ブッキングのマーケットがありますが、それぞれがスコアリング単位になります。</p>
      </div>
      <a class="title" style="color: #0a74ef !important; font-weight: 750; font-size: 0.9rem !important; cursor: pointer; text-decoration: none;" href="#top">トップへ戻る</a>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Soccer" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          サッカー
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、すべての試合マーケットは予定された90分間のプレー終了時の結果に基づきます。これは、アディショナルタイム(インジャリータイムやロスタイム)は含みますが、延長戦、PK戦、ゴールデンゴールは含みません。</p>
          </li>
          <li>
            <p>試合が早く終了した、または中断されて試合が無効とみなされた場合、完了までプレイしたピリオド(前半など)はアクションとなります。試合が開始され、開始から12時間以内に終了しない場合、終了していないピリオドのすべてのベットは無効になります。85分以上プレイした後に審判が試合を終了させた場合、このルールの適用外となります。この場合、すべてのピリオドがアクションとなります。</p>
          </li>
          <li>
            <p>オウンゴールは指定された競技者のマーケットにカウントされません。</p>
          </li>
          <li>
            <p>サッカーの試合が中立地で行われる場合、その情報がマーケットで示されているかどうかにかかわらず、すべてのベットがアクションとなります。AP Gamingでは常にホームチームを先に記載するよう心掛けていますが、当社はこの情報の正確性を保証しておらず、その試合に対するマーケットが提供された後に公式に会場が変更されない限り、すべてのベットがアクションとなります。アウェイチームの会場で試合が行われても、ホームチームと記載されたチームがその試合の公式の運営組織によってホームチームと見なされている場合は、すべてのベットがアクションとなります。</p>
          </li>
          <li>
            <p>インプレイベットは、ビデオアシスタントレフリー(VAR)の決定がベットのオッズに大きく影響を与える場合、無効になります。ベットを無効にする必要がある場合、VARによる確認の起因となる当該ファウルのあった時刻が考慮されます。</p>
          </li>
          <li>
            <p>スコア、コーナー、およびレッドカード情報は、インプレイベットのマーケットの一部とみなされます。この情報がマーケットオファリングまたはベットスリップに不正確に表示されている場合、当該情報が表示されている間に行われたベットは無効とみなされます。</p>
          </li>
          <li>
            <p>ベットに継続時間が指定されていない限り、アディショナルタイムは含まれます。</p>
          </li>
          <li><span style="font-size: 12.0pt; line-height: 115%; font-family: 'Aptos',sans-serif; mso-ascii-theme-font: minor-latin; mso-fareast-font-family: DengXian; mso-fareast-theme-font: minor-fareast; mso-hansi-theme-font: minor-latin; mso-bidi-font-family: 'Times New Roman'; mso-bidi-theme-font: minor-bidi; mso-ansi-language: EN-US; mso-fareast-language: ZH-CN; mso-bidi-language: AR-SA;">All bets on World Cup Fixtures have action as long as the Fixture is completed within 72 hours of when it was originally scheduled to play.</span></li>
        </ol>
        <p id="Soccer-Market-Rules" style="font-weight: bold;">
          サッカーのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>ブッキング</strong>：イエローカードは1枚につき「1ブッキング」、レッドカードは1枚につき「2ブッキング」としてカウントされます。ただし、同一選手への2枚目のイエローカード（退場を伴う場合）は無視されるため、1人の選手が獲得できる最大のブッキング数は「3」となります。なお、試合に出場していない選手（ベンチ入り選手、交代済みの選手）、監督、コーチ、その他スタッフに対して出されたカードはカウントされません。ハーフタイム中に出されたカードは「後半のブッキングマーケット」に含まれます。一方、試合終了のホイッスルが吹かれた後に出されたカードは、その試合のマーケットには反映されません。</p>
          </li>
          <li>
            <p><strong>先に進む：</strong>チームの「先に進む」または「決勝で勝利」のマーケットは、どのチームが次のラウンドに進む、またはカップまたはトーナメントで優勝するかのベットです。試合またはステージが完了すると、移動、遅延、または延期されたかにかかわらず、いつでもどこでもベットはアクションとなります。</p>
          </li>
          <li>
            <p><strong>シーズンポイント：</strong>チームが指定された合計ポイントを超え、かつ予定された試合をすべてプレイすることが見込まれる場合、または残された試合数を考慮すると合計ポイントを超えられそうになく、かつ予定された試合をすべてプレイすることが見込まれる場合に確定します。チームがフルシーズンをプレイするかどうかについて合理的な疑いがある場合は、シーズンポイントマーケットは、全試合をプレイするまで確定しません。シーズンポイントマーケットが確定した後は、チームが何らかの理由で予定よりも少ない試合しかプレイしなかった場合でも、変更されません。</p>
          </li>
          <li>
            <p><strong>リーグ優勝&amp;降格マーケット：</strong>各チームがプレイした試合数に関係なく、そのリーグの公式結果に基づいてアクションになります。</p>
          </li>
          <li>
            <p><strong>ホーム対アウェイマーケット：</strong>ホーム対アウェイのマーケットでは、試合がチームの通常の競技場で行われない場合、最初に指定されているチームがホームチームとみなされます。</p>
          </li>
          <li>
            <p><strong>インプレイ2ウェイ(「アジアン」)ハンディキャップ</strong>：ベットは、ベットが行われた後のピリオドの残りの時間のスコアによって確定します。ベットが行われる前のスコアは、ここでは無視されます。</p>
          </li>
          <li>
            <p><strong>コーナー</strong>：コーナーキックのやり直しがあった場合、コーナーキックは1回だけカウントされます。コーナーキックが与えられたものの、コーナーキックが行われなかった場合はカウントされません。</p>
          </li>
          <li>
            <p><strong>PK戦：</strong>ハンディキャップマーケットは、行われたすべてのキックで得点されたゴールが含まれます。トータルマーケットは、最初の10キックのゴールのみカウントします。</p>
          </li>
          <li>
            <p><strong>次に得点するチーム：</strong>試合が完了したかどうかにかかわらず、このマーケットでのベットは得点するとすぐに有効になります。</p>
          </li>
          <li>
            <p><strong>X得点の先取：</strong>試合が完了したかどうかにかかわらず、このマーケットでのベットは得点するとすぐに有効になります。</p>
          </li>
          <li>
            <p><strong>試合前のプレイヤーマーケット：</strong>ベットがアクションになるためには、選手が先発で出場する必要があります。</p>
          </li>
          <li>
            <p><strong><em>Anytime Goalscorer:</em></strong><em> Bets will be graded for events based on normal time, including injury/stoppage time. Extra time and penalty shoot-outs do not count. Own goals do not count.</em></p>
          </li>
          <li>
            <p><strong>決勝トーナメントプレイヤーマーケット: &nbsp;</strong>前後半と延長戦の時間に起きたイベントがカウントされます。PK戦でのイベントはカウントされません。</p>
          </li>
          <li>
            <p><strong>アジアンハンディキャップマーケット：</strong>ハンディキャップは、1つのオッズバリューに2つのハンディキャップ、または -1.25などの4分の1のハンディキャップ(つまり-1と-1.5)として表します。これらのマーケットでのベットは、オッズのリストのハンディキャップごとに、ステークの半分に分割されます。</p>
          </li>
          <li>
            <p><strong>トータルマーケット：</strong>トータルは、1つのオッズバリューに2つのトータル、または2.75などの4分の1のトータル(つまり2.5と3.0)として表します。これらのマーケットでのベットは、オッズのリストのトータルごとに、ステークの半分に分割されます。</p>
          </li>
          <li><strong>Tournament Top Goalscorer:</strong> <em>Goals scored in regular time and extra time count. Penalty shoot-outs do not count. Own goals do not count. In the event of a tie, the market will be settled on whom the official governing body awards the top goalscorer or equivalent award to. The exception is if the governing body shares the awarding of top goalscorer, then the following tie breaker rules will be applied in this order to determine the winner of the market: 1) most assists in the tournament, 2) least minutes played in the tournament, 3) alphabetical order.</em></li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Baseball" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          野球
        </h3>
        <ol>
          <li>
            <p>ピッチャーは、最初の投球を行うと先発したとみなされます。投手以外は、スターティングメンバーに入って最初の打席に立ったときに先発したとみなされます。</p>
          </li>
          <li>
            <p>マーケットに1人または2人の競技者の名前がはっきりと入っている場合、ベットをアクションにするためには、記載されているすべての競技者が試合に先発出場する必要があります。このルールの例外は、競技者の「セーブ」統計のマーケットです。このマーケットは、競技者が試合に出場したかどうかにかかわらず、アクションになります。</p>
          </li>
          <li>
            <p>ゲームピリオドマネーラインマーケットで試合開始前に行われたベットは、5回裏(ホームチームが勝っている場合は5回表)まで終了すると、アクションになります。9回裏(ホームチームが勝っている場合は9回表)が終了する前にコールドゲームとなった場合は、最後の回が終了した時点のスコアが最終のものとみなされます。マネーライン以外のすべてのゲームピリオドマーケットは、9回裏(ホームチームが勝っている場合は9回表)を終了した場合のみアクションになります。試合が終了していなくても、プレイが終了したピリオドはアクションになります。</p>
          </li>
          <li>
            <p>ゲームピリオドインプレイマーケットでは、9回裏(ホームチームが勝っている場合は9回表)を終了するとアクションになります。試合が終了していなくても、プレイが終了したピリオドはアクションになります。</p>
          </li>
          <li>
            <p>「マーシールール」が明示的にルールに含まれる試合では、マーシールールが適用されたときに、すべてのピリオドが完了したとみなされます。</p>
          </li>
          <li>
            <p>野球の試合のファーストハーフピリオドは、5回裏の終了時の結果に基づいています。試合の前にファーストハーフハンディキャップおよびマネーラインのマーケットで行われたベットは、5回裏(または試合が5回表でコールドになり、ホームチームが勝者と宣言された場合は5回表)を終了するとアクションとなります。その他のすべてのファーストハーフマーケット(インプレイファーストハーフハンディキャップおよびマネーラインのマーケットを含む)は、5回裏を完了するとアクションになります。</p>
          </li>
          <li>
            <p>MLBの試合が中断し、試合開始から12時間以上あとに再開されることになった場合、ゲームピリオドマーケットのすべてのプレゲームベットは無効になり、完了したピリオドのベットはアクションになります。次の例外があります。</p>
            <ol style="list-style-type: upper-roman;">
              <li>
                <p>MLBのプレイオフとプレイインの試合は、試合が終了すればいつでもアクションになります。</p>
              </li>
              <li>
                <p>ゲームピリオドマネーラインへのベットは、少なくとも5回裏(ホームチームが勝っている場合は5回表)まで終了すると、最後に終了した回の終了時点の点数に基づいてアクションになります。</p>
              </li>
              <li>
                <p>競技者統計マーケットは、試合が開始された日または翌日に試合が終了するとアクションになります。</p>
              </li>
              <li>
                <p>レギュラーシーズンで9イニング後に延期となった試合のうち、競技者統計マーケット以外のマーケットは、最終イニングの終了時点のスコアに応じて有効となります。</p>
              </li>
            </ol>
          </li>
          <li>
            <p>MLBの試合が中断し、試合開始から30時間以上あとに再開されることになった場合、ゲームピリオドマーケットのすべてのライブベットは無効になり、完了したピリオドのベットはアクションになります。試合が中断し、試合開始から30時間以内に再開される場合、ピリオドが完了した時点ですべてのライブベットがアクションになります。MLBのプレイオフとプレイインの試合へのライブベットは、試合が終了すればいつでもアクションになります。</p>
          </li>
          <li>
            <p>「ホーム」チームがホームスタジアムでプレイしていない場合、その試合の最初の1球を投げた先発ピッチャーのチームがホームチームとみなされます。</p>
          </li>
          <li>
            <p>7回ダブルヘッダールール：</p>
          </li>
          <ol style="list-style-type: upper-roman;">
            <li>
              <p>ゲームピリオドマネーラインマーケットで試合開始前に行われたベットは、5回裏(ホームチームが勝っている場合は5回表)まで終了すると、アクションになります。マネーライン以外のすべてのゲームピリオドマーケットは、7回裏(ホームチームが勝っている場合は7回表)を終了した場合のみアクションになります。試合が終了していなくても、プレイが終了したピリオドはアクションになります。</p>
            </li>
            <li>
              <p>ゲームピリオドインプレイマーケットでは、7回裏(ホームチームが勝っている場合は7回表)を終了するとアクションになります。試合が終了していなくても、プレイが終了したピリオドはアクションになります。</p>
            </li>
            <li>
              <p>7回ダブルヘッダーのすべてのベットは、それが7回制の試合であると示されていない場合、無効になります。</p>
            </li>
            <li>
              <p>7回制の試合が終了しなかった場合、野球ルール3、7、8が適用され、「7回裏(ホームチームが勝っている場合は7回表)」が「9回裏(ホームチームが勝っている場合は9回表)」に置き換えられるとみなされます。</p>
            </li>
          </ol>
          <li>
            <p>野球のベットは、両チームの先発ピッチャーが誰であるかにかかわらず指定のオッズで成立します。</p>
          </li>
          <li>
            <p>MLB(マイナーリーグ)のG1/G2ダブルヘッダー： G1またはG2 (第1試合または第2試合)を指定したMLB(マイナーリーグ)ダブルヘッダーゲームとして指定されます。G1またはG2の指定なく試合が掲載され、MLB(マイナーリーグ)からその日の試合の対戦チームによるダブルヘッダーが発表された場合、G1またはG2の指定のない試合と、それに関連するG1またはG2の指定のないすべてのコンテストはノーアクションとなります。</p>
          </li>
        </ol>
        <p id="Baseball-Market-Rules" style="font-weight: bold;">
          野球のマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>MLBレギュラーシーズン勝利数</strong>：チームが指定された勝利数を超え、かつ158試合以上プレイすることが見込まれる場合、または残された試合数を考慮すると勝利数を超えられそうになく、かつ158試合以上プレイすることが見込まれる場合に確定します。チームが158試合以上プレイするかどうかについて合理的な疑いがある場合は、シーズン勝利数マーケットは、158試合以上プレイするまで確定しません。追加の優勝決定試合(ワイルドカード、ディビジョンなど)は、レギュラーシーズン勝利数にはカウントされません。シーズン勝利数マーケットが確定した後は、チームが何らかの理由で予定よりも少ない試合しかプレイしなかった場合でも変更されません。</p>
          </li>
          <li><strong>MLBア・リーグまたはナ・リーグ優勝チーム：</strong>ワールドシリーズ進出チームが、各リーグの優勝チームとなります。</li>
          <li>
            <p><strong>塁打数</strong>：1塁打は1、2塁打は2、3塁打は3、ホームランは4とカウントされます。これ以外の種類のプレイは、塁打数マーケットではカウントされません。</p>
          </li>
          <li>
            <p><strong>投球回</strong>：完了した回ごとに1がカウントされ、その後アウト1つを記録するごとに0.1が加算されます。</p>
          </li>
          <li>
            <p><strong>地区優勝チーム</strong>：マーケットは、地区の全チームが予定された試合の90%以上をプレイ済みであることを条件として、シーズン終了時の順位で決定されます。2つ以上のチームが同一の成績の場合、優勝チームは、1)優勝決定試合で勝ったチーム、または 2)プレイオフのシードを決定するそのリーグのタイブレーカーシステムにより勝者とみなされたチームになります。</p>
          </li>
          <li>
            <p><strong>シーズンホームラン王</strong>：ホームラン数の首位が並んだ場合、打率がタイブレーカーとして使用されます。</p>
          </li>
          <li>
            <p><strong>シーズン競技者マッチアップ</strong>：どちらかの選手が所属チームの最初の10試合のうち少なくとも1試合に出場しなかった場合、すべてのベットは無効になります。</p>
          </li>
          <li>
            <p><strong>ヒット+得点+エラーマーケット</strong>：アクションとなるには、試合完了までプレイする必要があります。試合が延長回でコールドまたは中断された場合、結果は最終回の裏が終了した後に決定されます。ただしホームチームのスコアがその回の裏で同点となった場合、結果は試合がコールドとなったときに決定されます。</p>
          </li>
          <li>
            <p><strong>ノーヒットノーランマーケット</strong>：試合が最後までプレイされたことを条件に、1人または複数ピッチャーの継投によるノーヒットノーランがカウントされます。</p>
          </li>
          <li>
            <p><strong>競技者統計マーケット：</strong>アクションとなるには、試合が最後まで行われる必要があります。試合が終了前に中断され、翌日再開された場合、両日の統計がこれらのマーケットの結果にカウントされます。試合が翌日に再開されなかった場合、すべてのベットが無効になります。また、指定された選手のベットが統計マーケットでアクションとなるには、その選手が先発出場する必要があります。</p>
          </li>
          <li>
            <p><strong>競技者統計マッチアップマーケット</strong>：両方の競技者が先発し、試合が最後までプレイされれば、すべてのベットはアクションです。</p>
          </li>
          <li>
            <p><strong>ホーム/アウェイマーケット</strong>：オファーで提示されている通り、すべての予定された試合で9回裏または9回表(ホームチームがリードしている場合)を終了する必要があります。9回以上が終わった後で試合が中断された場合、最後に表裏が完了した回のスコアがホーム/アウェイのベットに使用されます。</p>
          </li>
          <li>
            <p><strong>MLBレギュラーシーズンの勝率</strong>：レギュラーシーズンが終了した時点でベットが確定されます。ベットは、チームがレギュラーシーズンの試合を140試合以上終了すれば成立します。すべてのプレイインゲームは、レギュラーシーズンの勝率には考慮されません。</p>
          </li>
          <li>
            <p><strong>MLB打席マーケット：</strong>MLB打席マーケットは、試合の公式ボックススコアの結果に基づき確定されます。ただし、犠牲バント、敬遠、キャッチャーの打撃妨害に対しては、すべてのベットが無効となります。イニングの打席が開始され、そのイニングで完了しなかった場合(盗塁が失敗してスリーアウトになった、バッターが負傷したなど)、その打席に関するすべてのベットは無効となり、次のイニングで適用可能となればマーケットが再び提供されます。</p>
          </li>
          <li>
            <p><strong>MLBオールスターゲーム - ホームランダービー：</strong>MLBオールスターゲームの9回終了時にホームランダービーで勝敗を決める場合、AP Gamingはホームランダービーで勝利したチームに1得点与えるものとします。すべてのフルゲームマーケットはこの追加得点も含めて決定されます。例えば、MLBオールスターゲームの9回終了時に4-4の引き分けで、その後のホームランダービーでアメリカンリーグが勝利したとします。この場合、アメリカンリーグは5-4のスコアで勝利したことになり、この5-4のスコアに基づいてすべてのフルゲームベットが決定されます。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Basketball" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          バスケットボール
        </h3>
        <ol>
          <li>
            <p>NBAのゲームピリオドのすべてのベットは、試合が43分未満で終了した場合、無効となります。その他の試合はすべて、ゲームピリオドのベットは、試合が35分未満で終了した場合は無効となります。ピリオドのベットは、ピリオドの終了までプレイされればアクションになります。</p>
          </li>
          <li>
            <p>「イラムエンディング」が使用される場合、そのエンディングを含むピリオドのベットがアクションになるには、ターゲットスコアを達成する必要があります。試合の実際の長さにかかわらず、ターゲットスコアを達成すると、最終スコアに基づいてすべてのベットが確定します。</p>
          </li>
          <li>
            <p>ゲームおよびセカンドハーフピリオドのベットは、すべての延長戦が結果に含まれます。</p>
          </li>
        </ol>
        <p><strong>サブスポーツルール</strong></p>
        <p><strong>スリーオンスリーバスケットボール</strong></p>
        <ol>
          <li>
            <p>10分間が経過し、かつすべての延長戦が完了した時点、またはチームが21点を得点した時点でゲームピリオドは終了とみなされます。ゲームが完了しなかった場合、そのゲームのすべてのベットは無効になります。</p>
          </li>
        </ol>
        <p id="Basketball-Market-Rules" style="font-weight: bold;">
          バスケットボールのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>NBAレギュラーシーズン勝利数：</strong>チームが指定された勝利数を超え、かつNBAレギュラーシーズン内に予定された試合を80試合以上プレイすることが見込まれる場合、または残された試合数を考慮すると勝利数を超えられそうになく、かつ予定された試合を80試合以上プレイすることが見込まれる場合に確定します。チームが80試合プレイするかどうかについて合理的な疑いがある場合、シーズン勝利数マーケットは、80試合プレイするまで確定しません。シーズン勝利数マーケットが確定した後は、結果が確定しているためチームが80試合より少ない試合しかプレイしなかった場合でも変更されません。</p>
          </li>
          <li>
            <p><strong>NBAカンファレンス優勝：</strong>カンファレンス優勝フューチャーの勝利チームの場合、各カンファレンスの勝者がNBAファイナルに進出するチームとなります。</p>
          </li>
          <li>
            <p><strong>競技者の統計</strong>：1人または2人の選手名が含まれる試合前および試合中のバスケットボールマーケットの場合、試合で特に明示されていない限り、ベットが有効になるためには、リストに挙がっている全選手が出場する必要があります。</p>
          </li>
          <li>
            <p><strong>ブザービーターマーケット</strong>：「ブザービーター」は、試合の最後にゲームクロックの残り時間が全く残っていない状態で放たれたショットであること、かつ、そのショットが入ると同時に、ショットを放った側でそれまで負けていたか同点だったチームの勝ちが決まることと定義されています。</p>
          </li>
          <li>
            <p><strong>NBA地区優勝：</strong>NBA地区優勝マーケットは、その地区のすべてのチームがレギュラーシーズンの終わりに予定されていた試合の半数以上をプレイした場合、アクションになります。同順位の場合はNBAの決定により勝者が決まります。</p>
          </li>
          <li>
            <p><strong>ダブル/トリプルダブルマーケット</strong>：「ダブルダブル」は、次のカテゴリーの少なくとも2つで10以上を意味します：ポイント、リバウンド、アシスト、スチール、またはブロック。「トリプルダブル」は上記のカテゴリーの3つで10以上です。</p>
          </li>
          <li><strong>NBA Player Statistic Settlement: </strong>After the completion of each NBA game, using official NBA Statistics from nba.com, we will settle the following markets: Points and Three-Point Field Goals Made. Due to the fact that the NBA sometimes reviews and revises other statistical categories, we will wait a period of time before settling those other markets using NBA.com statistics. Once settlement has occurred on NBA player statistics markets, it will be final and will not be revised for any subsequent NBA statistical changes.</li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Volleyball" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          バレーボール
        </h3>
        <ol>
          <li>
            <p>すべてのマッチピリオドマーケットは、スコアリング単位としてセットを使用します。その他のすべてのピリオドは、スコアリング単位としてポイントを使用します。</p>
          </li>
          <li>
            <p>ゴールデンセットとは、複数のレグで対戦し試合成績がタイになった2チームが、最終的な勝敗を決めるために行う延長戦です。ゴールデンセットは、標準的なベストオブ3またはベストオブ5の試合の勝敗を決める最終セットのことではありません。なぜならそうした試合は複数レグのマッチアップではないためです。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Golf" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ゴルフ
        </h3>
        <ol>
          <li>
            <p>トーナメントでプレイしたホール数が、何らかの理由(天候など)により、予定されているホール数から36またはそれ以上に減った場合、最後に完了したラウンドの完了前に行われたベットはアクションとなります。最後に完了したラウンドの後に行われたベットは無効になります。ホールが36ホール未満に減らされて完了した場合、既に確定したラウンドとマーケットを除いて、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p>トーナメントの選手成績のベットは、選手がトーナメントを開始しない場合、無効になります。トーナメントの開始には、予選ラウンドのプレイが含まれます。</p>
          </li>
          <li>
            <p>選手がティーから第一打を打つと、その選手がプレイしたとみなされます。選手がティーオフした後は、その後に撤退したとしても、その選手が含まれるすべてのマーケットがアクションになります。</p>
          </li>
          <li>
            <p>2人以上の選手が規定のプレイ後に1位タイになった場合、AP Gamingは、優勝決定に使用される方法を内容を問わず尊重します。1位タイでタイブレーカーで勝利しなかった選手は全員、2位で終了したとみなされます。</p>
          </li>
          <li>
            <p>スキンズのトーナメントでは、競技者の合計獲得金額で勝者が決定します。引き分けの場合はトーナメントで決められた形式が採用されます。差異が生じた場合は、トーナメントで正式に宣言された優勝者が獲得金額の勝者よりも優先されます。</p>
          </li>
        </ol>
        <p><strong>団体戦(Ryder Cupなど) </strong></p>
        <ol>
          <li>
            <p><strong>デイウィナー/セッションウィナー：</strong> その日に予定された試合のみが確定にカウントされます。試合が予定された日に完了せずに持ち越された場合は、前日のデイウィナー/セッションウィナーのマーケットにカウントされます。</p>
          </li>
          <li>
            <p><strong>ウィニングパットを沈める人物：</strong>トーナメントで勝利を決する勝ち点の1ポイントまたは引き分けの0.5ポイントを獲得した選手に基づいて確定します。例えば、Presidents Cupでは15.5ポイント目、またはRyder Cupでは14.5ポイント目を獲得した選手です。トーナメントが引き分けの場合は(例：Presidents Cupでは15対15、Ryder Cupでは14対14)、ウィニングパットを沈めた選手へのベットを含む、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p><strong>トーナメントハンディキャップベッティング：</strong>予定されたすべての試合が完了してから確定が決まります。予定された試合数が完了できない場合、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p><strong>試合ウィナー(2-Way)：</strong>試合ウィナー(2-Way)マーケットは、勝者に基づいて確定し、プレイされたすべてのエキストラホールが含まれます。公式結果がタイの場合、試合ウィナー(2-Way)へのベットは無効になります。</p>
          </li>
          <li>
            <p><strong>試合ウィナー(3-Way)：</strong>試合結果(3-Way)およびウィニングマージンには、エキストラホールは含まれません(プレイされた場合)。</p>
          </li>
        </ol>
        <p id="Golf-Market-Rules" style="font-weight: bold;">
          ゴルフのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>マッチアップ：</strong>両方の選手がティーオフしなかった場合、ベットは無効になります。1人の選手が予選落ちした場合、予選の後で何が起きたとしても、もう片方の選手が勝者とみなされます。両方の選手が予選落ちした場合は、予選終了後にスコアが低い方の選手が勝者とみなされます。</p>
          </li>
          <li>
            <p><strong>ゴルフ選手のラウンドスコア：</strong>選手がラウンドを終了しない場合、ベットは無効になります。</p>
          </li>
          <li>
            <p><strong>次のホールのスコア：</strong>競技者がホールを終了しない場合、ベットは無効になります。結果は選手がグリーンを離れたときに決定され、その後ペナルティが発生しても関係ありません。</p>
          </li>
          <li>
            <p><strong>ハンディキャップ：</strong>マイナスのハンディキャップは選手のスコアに足され、プラスのハンディキャップはスコアから引かれます。その結果を比較し、スコアの最も低い選手が勝者となります。棄権や予選落ちによって出場選手のプレイしたホールの数が異なる場合、プレイしたホールの数の最も多い選手がハンディキャップベットで勝ちとなります。プレーオフはハンディキャップベットではカウントされません。</p>
          </li>
          <li><strong>トップ○位以内：</strong>対象選手が○位以内にタイで入った場合、その選手に賭けたベットは、同順位で並んだ選手の人数にかかわらずオッズ全額で支払われます。</li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Tennis" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          テニス
        </h3>
        <ol>
          <li>
            <p>競技者が棄権または失格になると、マッチマネーラインマーケットのベットは、1セットが終了している場合はアクションになり、それ以外の場合は無効になります。その他のマーケットのベットは、棄権または失格の前にピリオドが終了までプレイされていた場合を除いて、無効になります。</p>
          </li>
          <li>
            <p>試合の開始予定日から7日以内に試合が完了すれば、試合のすべてのベットはアクションです。</p>
          </li>
          <li>
            <p>開催場所、コート表面、またはインドアからアウトドアやその逆の変更が行われた場合でも、すべてのベットはアクションとみなされます。</p>
          </li>
          <li>
            <p>タイブレークまたはマッチタイブレークはすべて1ゲームとしてカウントされます。<br><br>ITFのシングルス(グランドスラムを除く)およびすべてのダブルスにおいて、タイブレーク(スーパータイブレークを含む)で最終セットの勝敗を決める場合、ライブマーケットおよび有効なすべてのマーケットでタイブレークは1ゲームとしてカウントされます。ただし、試合前のスプレッドマーケットおよびトータルマーケットは無効になります。その他すべてのマーケットにおけるベットはアクションとなります。</p>
          </li>
          <li>
            <p>試合が「プロセット」になった場合：第1セットおよび第2セットのマネーラインとマッチマネーラインがアクションになり、マッチピリオドのその他のすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>すべてのフューチャーベットは、マーケットで特定の競技者の開始が求められていない限り、アクションです。</p>
          </li>
          <li>
            <p>すべてのインプレイベットがアクションになるには、次のポイントがプレイされなければなりません。いずれかの競技者が棄権した、失格になった、または何らかの理由でプレイを続けられなくなった場合は、最後のポイントが終了した後に行われたすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>特に明記されていない限り、すべてのテニスハンディキャップとトータルのベットはスコアリング単位としてゲーム勝利を使用します。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Table-Tennis" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          卓球
        </h3>
        <ol>
          <li>
            <p>競技者が棄権または失格になると、マッチマネーラインマーケットのベットは、1セットが終了している場合はアクションになり、それ以外の場合は無効になります。その他のマーケットのベットは、棄権または失格の前にピリオドが終了までプレイされていた場合を除いて、無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Badminton" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          バドミントン
        </h3>
        <ol>
          <li>
            <p>選手またはチームがリタイアした際、または失格になった際、マッチマネーラインマーケットのベットは、1ゲームが終了した場合にはアクションとなり、それ以外の場合には無効となります。他のマーケットのベットは、リタイアまたは失格までにピリオドが最後までプレーされなかった場合には無効となります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Snooker" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          スヌーカー
        </h3>
        <ol>
          <li>
            <p>試合が開始されたものの完了しなかった場合、公式結果がある限りはマネーラインのベットはアクションになります。その他のすべてのマーケットは無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Rugby" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ラグビー
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、プレイされたオーバータイムはすべてのマッチピリオドマーケットに含まれます。</p>
          </li>
          <li>
            <p>短時間のプレイが予定されている試合を除いて、プレイ時間が80分に満たない場合、すべてのベットは無効になります。</p>
          </li>
        </ol>
        <p id="Rugby-Market-Rules" style="font-weight: bold;">
          ラグビーのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>得点マージンマーケット：</strong>規定時間の得点だけがカウントされ、オーバータイムまたは「ゴールデンポイント」は含まれません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="American-Football" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          アメリカンフットボール
        </h3>
        <ol>
          <li>
            <p>試合が55分未満で中断し、中断から12時間以内に完了されなかった場合、そのゲームピリオドのすべてのベットは無効になり、終了したピリオドのベットはアクションになります。試合が55分以上プレイした後に中断され、中断から12時間以内に再開されなかった場合、試合が後日完了したかどうかにかかわらず、すべてのベットはアクションになり、試合が中断された時点のスコアが最終のものとみなされます。また、全クオーターの累積プレイ時間が55分未満の場合、フルゲームマーケットはノーアクションとなり、ベットは無効になります。</p>
          </li>
          <li>
            <p>試合が本来予定されていた日時の12時間以内に開始されなかった場合、すべてのベットは無効になります。</p>
          </li>
          <li>
            <p>試合およびセカンドハーフピリオドのベットにはオーバータイムに得点されたポイントが含まれます。</p>
          </li>
          <li>
            <p>NFLプロボウルのベットは、プレイが行われたピリオド数や各ピリオドでのプレイ時間(分)に関係なく、成立になります。</p>
          </li>
          <li>特定のリーグが明記されていない限り、NFL、NCAA、UFL、CFLにはすべてアメリカンフットボールの共通ルールが適用されます。</li>
        </ol>
        <p id="American-Football-Market-Rules" style="font-weight: bold;">
          アメリカンフットボールのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>次に得点するチーム</strong>：エクストラポイントと2ポイントコンバージョンは、得点とはみなされません。「トライ後のポイント」はタッチダウンによる得点の一部とみなされます。</p>
          </li>
          <li>
            <p><strong>パス統計：</strong>指定されたクォーターバックが1回以上のパスを試みない場合、ベットは無効です。</p>
          </li>
          <li>
            <p><strong>ラッシュ統計オーバー/アンダー</strong>：指定された選手がプレイしたもののラッシュを試みなかった場合、トータルラッシュヤード数と最初に試みたラッシュヤード数はゼロとみなされます。</p>
          </li>
          <li>
            <p><strong>レシーブ統計オーバー/アンダー</strong>：指定されたレシーバーがプレイしたもののキャッチしなかった場合、トータルレシーブヤード数と最初に試みたレシーブヤード数はゼロとみなされます</p>
          </li>
          <li>
            <p><strong>得点時間</strong>：マーケットで指定される秒は、その秒を含みます。したがって試合のその秒に起きたイベントはカウントされます。</p>
          </li>
          <li>
            <p><strong>ファーストダウン</strong>：ペナルティとポゼッション変更で得られたファーストダウンはカウントされません。</p>
          </li>
          <li>
            <p><strong>連続得点：</strong>エクストラポイントと2ポイントコンバージョンはタッチダウンの一部としてカウントされ、連続得点イベントとはみなされません。エクストラポイントまたは2ポイントコンバージョンの試みに対する対戦相手のリターンも、これらのマーケットにはカウントされません。</p>
          </li>
          <li>
            <p><strong>最長タッチダウン</strong>：タッチダウンがない場合、これらのマーケットは無効になります。</p>
          </li>
          <li>
            <p><strong>エンターテインメントプロップ</strong>：国歌斉唱などの歌唱時間の長さに関するコンテストでは、アーティストが歌い始めてからその歌を歌い終わるまでの時間を計測します。実際の歌唱前後の楽器のみの演奏時間は、歌唱時間に含まれません。</p>
          </li>
          <li>
            <p><strong>スパーボールセレブプロップス</strong>：スーパーボウルでセレブ関連の予想コンテストに対するベットアクションについては、その有名人がコンテストに実際に参加する必要があります。</p>
          </li>
          <li>
            <p><strong>スペシャルチームとディフェンシブタッチダウン</strong>：スペシャルチームタッチダウンとみなされる唯一のタッチダウンは、ボールが実際にキックまたはパントされたプレイです。これには次のものが含まれます：キックオフリターン、パントリターン、ファンブルしたキックオフリターンのリターン、ファンブルしたパントリターンのリターン、ブロックしたフィールドゴールリターン、またはブロックしたパントリターン。ボールを奪ったチームがフェイクのフィールドゴール、フェイクのパントからタッチダウンした場合、オフェンシブタッチダウンとみなされます。</p>
          </li>
          <li>
            <p><strong>タッチダウンを得点する競技者</strong>：タッチダウンへのパスは、タッチダウンの得点とはみなされません。ボールをエンドゾーンで保持していた競技者だけがタッチダウンを得点したとみなされます。</p>
          </li>
          <li>
            <p><strong>パスインターフェアペナルティ</strong>：オフェンスとディフェンス両方のインターフェアがカウントされますが、有効とみなされるためには、ペナルティを受け入れ、実施される必要があります。ペナルティが拒否された場合や、インターフェアの実施を打ち消す相殺ペナルティがある場合、勝者は次回のインターフェアペナルティで決定されます。</p>
          </li>
          <li>
            <p><strong>ホールディングペナルティ</strong>：オフェンスとディフェンス両方のホールディングがカウントされますが、有効とみなされるためには、ペナルティを受け入れ、実施される必要があります。ペナルティが拒否された場合や、ホールディングの実施を打ち消す相殺ペナルティがある場合、勝者は次回のホールディングペナルティで決定されます。</p>
          </li>
          <li>
            <p><strong>最長キックオフリターン</strong>：各チームが1回以上のキックオフリターンを行わない場合、ベットは無効です。</p>
          </li>
          <li>
            <p><strong>最長パントリターン</strong>：各チームが1回以上のパントリターンを行わない場合、ベットは無効です。</p>
          </li>
          <li>
            <p><strong>得点した選手の人数</strong>：セイフティ以外の得点したすべての選手がカウントされます。</p>
          </li>
          <li>
            <p><strong>最初のタッチダウンパスの距離オーバー/アンダー</strong>：指定されたクォーターバックが1回以上のタッチダウンパスを完了しない場合、ベットは無効です。</p>
          </li>
          <li>
            <p><strong>AFC/NFCチャンピオンシップフューチャー</strong>：各カンファレンスのチャンピオンは、スーパーボウルに出場するチームです。</p>
          </li>
          <li>
            <p><strong>レギュラシーズン勝利数</strong>： チームがレギュラーシーズンの残り試合数にかかわらず勝利数の合計を超える、あるいは勝利数の合計を超えることが不可能であり、かつレギュラーシーズン全試合に出場する見込みがある場合、マーケットは精算されます。チームがレギュラーシーズンの全試合を実際にプレイするかどうかに合理的な疑義がある場合、そのチームの「レギュラーシーズン勝利数マーケット」はシーズン終了まで精算されません。一度「レギュラーシーズン勝利数マーケット」が精算された場合、たとえその後チームが全試合をプレイしなかったとしても、結果は確定済みとして変更されません。また、リーグの統括機関が「不戦敗」と判断した試合は、プレイされた試合として扱われ、その試合に関して統括機関が定めた結果が、それぞれのチームのシーズン勝利数としてカウントされます。</p>
          </li>
          <li>
            <p><strong>NCAAフットボールシーズン勝利数：</strong>ボールゲームとカンファレンスチャンピオンシップゲームは、レギュラーシーズンの合計勝利数にはカウントされません。各チームがレギュラーシーズンに予定されたすべての試合をプレイしなければ、アクションになりません。</p>
          </li>
          <li>
            <p><strong>NCAAフットボールカンファレンスチャンピオンシップフューチャー</strong>：カンファレンスで公式のチャンピオンシップの試合がある場合、その試合の勝者はそのカンファレンスで優勝したものとみなされます。カンファレンスのディビジョンごとのオッズに関して、カンファレンスチャンピオンシップの試合に出場したチームはディビジョンで優勝したものとみなされます。</p>
          </li>
          <li>
            <p><strong>NFL週間マーケット</strong>：記載された週に行われる試合がキャンセルまたは延期となり、予定開始時刻から96時間以内に終了しなかった場合には、特定試合の結果にかかわらず、すべての週間マーケットが無効になります。</p>
          </li>
          <li>
            <p><strong>ハイズマン賞受賞者のはい/いいえ</strong>：競技者のチームの予定された最初の試合の前にベットが行われた場合、競技者がその試合でプレイしないと無効になります。</p>
          </li>
          <li>
            <p><strong>最初の得点の後で同点になる：「</strong>はい」は、最初の得点の後に同点になると勝者とみなされます。これにはタッチダウンの後の、エクストラポイントまたは2ポイントコンバージョンが試行される前に同点になった場合が含まれます。</p>
          </li>
          <li>
            <p><strong>キックオフ/パントリターンマッチアップ</strong>：アクションになるには、指定された両方の競技者が少なくとも1回キック/パントリターンを行う必要があります。</p>
          </li>
          <li>
            <p><strong>最終得点マーケット</strong>：タッチダウン、フィールドゴール、およびセイフティのみがカウントされます。タッチダウンに続くエクストラポイントと2ポイントコンバージョンはカウントされません。</p>
          </li>
          <li>
            <p><strong>パントマーケット</strong>：ブロックされたパントはチームパントマーケットのパントとしてカウントされますが、競技者のパント数マーケットにはカウントされません。</p>
          </li>
          <li>
            <p><strong>パンターマーケット</strong>：個人パンターの名前が付いたすべてのマーケット(「パンターによるパント数アンダー/オーバー」を除く)では、アクションになるにはパンターが1回以上パントする必要があります。</p>
          </li>
          <li>
            <p><strong>最長/最短フィールドゴール</strong>: 成功したフィールドゴールがない場合、ベットは無効になります。</p>
          </li>
          <li>
            <p><strong>オフェンシブドライブ：</strong> 攻撃側のタッチダウンまたはフィールドゴールは、オフェンシブスコアとしてカウントされます。チームがフェイクパントによるタッチダウンまたはフェイクフィールドゴールで得点した場合、これはオフェンシブスコアとしてカウントされます。特定のオフェンシブドライブとなるイベントは以下の通りです。</p>
            <ol>
              <li>
                <p>オフェンシブスコア(タッチダウンまたはフィールドゴール)</p>
              </li>
              <li>
                <p>セーフティ</p>
              </li>
              <li>
                <p>ターンオーバー(ファンブルまたはインターセプトが、本来ボールをスナップしたチームに戻った場合も含む)</p>
              </li>
              <li>
                <p>ダウン時のターンオーバー</p>
              </li>
              <li>
                <p>パント(ペナルティで無効にならない場合)</p>
              </li>
              <li>
                <p>フィールドゴールの試み(ペナルティで無効にならない場合)</p>
              </li>
              <li>
                <p>ハーフの終了</p>
              </li>
              <li>
                <p>レギュレーションまたはオーバータイムの終了</p>
              </li>
            </ol>
          </li>
          <li>
            <p><strong>最初または最後のタッチダウンマーケット</strong>：最初または最後のタッチダウンを決めた(または決めなかった)個人のプロポジションについては、いずれかのチームがその試合で決めた最初(または最後)のタッチダウンに基づいてグレードが決定されます。該当の試合でタッチダウンが1回も決まらない場合、特定の選手の全コンテストが有効になります(「アンダー」ベットが勝ちとなります)。</p>
          </li>
          <li>
            <p>各統計マーケットに記載のその他すべてのルールに加えて、アクションとなるには特定の選手がプレーする必要があります。</p>
          </li>
          <li>
            <p><strong>NFL選手統計の確定：</strong>NFL選手統計マーケットはひとたび確定されると、それが最終的なものとなります。その後NFL統計でいかなる変更があろうと、それに合わせて修正されることはありません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Aussie-Rules" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          オージールール
        </h3>
        <ol>
          <li>
            <p>すべてのオージールールズの試合は、80分以上のプレイを完了しなければアクションになりません(試合時間がそれより短い試合は除きます)。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Futsal" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          フットサル
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、プレイされた延長時間はすべてのマッチピリオドマーケットに含まれません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Cricket" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          クリケット
        </h3>
        <ol>
          <li>
            <p>テストマッチで4イニングを完了しなかった場合、マネーラインベットは公式発表に基づいて確定され、マッチピリオドオーバー/アンダーマーケットは無効になります。試合が完了しなかった場合でも、完了したピリオドへのベットはアクションになります。</p>
          </li>
          <li>
            <p>1日限りの国際マッチまたはトゥエンティ20マッチが、予定されたオーバー数以上を完了しなかった場合、マネーラインベットは公式発表に基づいて確定され、マッチピリオドオーバー/アンダーマーケットは無効になります。試合が完了しなかった場合でも、完了したピリオドへのベットはアクションになります。</p>
          </li>
          <li>
            <p>特に明記されていない限り、マッチピリオドのベットにスーパーオーバーでのプレイは含まれません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Curling" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          カーリング
        </h3>
        <ol>
          <li>
            <p>特に明記しない限り、「エキストラエンド」は常に結果に含まれます。</p>
          </li>
          <li>
            <p>プレイが行われ、公式結果のある試合は、完了したとみなされます。</p>
          </li>
          <li>
            <p>チームは時間切れになると試合の権利を失い、対戦相手のチームが公式に勝者となります。試合のベットは公式結果に基づいて評価されます。スプレッドマーケットおよびトータルマーケットでのベットは無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Cycling" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          自転車競技
        </h3>
        <p><strong>アウトライト/ステージ勝者/ポイント順位/山岳賞/チーム順位で勝つために</strong></p>
        <ol>
          <li>
            <p>失格者が出た場合、またはレース結果が変更となる場合は、表彰式において発表される結果をもとにベットが確定します。</p>
          </li>
          <li>
            <p>何らかの理由でレースが延期された場合、そのレースの予定日の一週間以内にレースが開始されれば、ベットはアクションです。</p>
          </li>
          <li>
            <p>レース開始前にベットされたその他すべてのレース勝者マーケットでは、出場者以外に対する賭け金が返金されます。</p>
          </li>
          <li>
            <p>複数ステージのイベントでいずれかのステージがキャンセルされた場合、またはルートが変更された場合は、1ステージ以上が終了していれば、最後に終了したステージ後の公式順位が結果に反映されます。</p>
          </li>
          <li>
            <p>ステージ間で価格が改訂される複数ステージのイベントでは、最後に終了したステージ後に行われたベットは無効となります。</p>
          </li>
          <li>
            <p>ベットは、最終順位が最高となった競技者に対して確定されます。公式順位で複数の競技者が同タイムとなった場合は、順位が上の競技者が勝者とみなされます。双方の競技者が同じ最終順位となった場合にのみ、デッドヒートが適用されます。</p>
          </li>
        </ol>
        <p><strong>個々のマッチベット</strong></p>
        <ol>
          <li>
            <p>各ステージのマッチベッティングでベットが成立するためには、マッチベットの対象となるすべての競技者がステージをスタートする必要があります。</p>
          </li>
          <li>
            <p>各ステージのマッチベッティングでベットが成立するためには、そのマッチベットにおいて1人以上の競技者がステージを完走する必要があります。</p>
          </li>
          <li>
            <p>各ステージのマッチベッティングでいずれの競技者もステージを完走できなかった場合は、その試合に対するベットが無効となります。</p>
          </li>
          <li>
            <p>特定のステージまたはアウトライトマーケットのフィールドにおいて、ある競技者がベッティングの対象となっている場合、ベットが成立するためには、その競技者がスタートする必要があります。対象の競技者がスタートできなかった場合は、すべてのベットが無効となります。</p>
          </li>
          <li>
            <p>複数ステージのマーケットでは、マッチベットは最終順位が最高となった競技者に対して確定されます。ベットが成立するためには、いずれの競技者もスタートする必要があります。1人の競技者のみがゴールした場合は、その競技者が勝者とみなされます。いずれの競技者もゴールできなかった場合は、いずれの競技者に対するベットも無効となります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Darts" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ダーツ
        </h3>
        <ol>
          <li>
            <p>各競技者が最初のダーツを投げると、その試合および完了したピリオドは、いずれかの競技者が棄権したとしてもアクションになります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Squash" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          スカッシュ
        </h3>
        <ol>
          <li>
            <p>競技者が棄権または失格になると、マッチマネーラインマーケットのベットは、1セットが終了している場合はアクションになり、それ以外の場合は無効になります。その他のマーケットのベットは、棄権または失格の前にピリオドが終了までプレイされていた場合を除いて、無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Athletics" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          陸上競技
        </h3>
        <ol>
          <li>
            <p><strong>マッチアップマーケット：</strong>競技の最新ラウンドへ進む競技者が勝者とみなされます。同じ予選ラウンドで競技者が両方とも敗退した場合は、同じ時間に開始される同じレースで競ったのであれば、そのレースで成績の良い方が勝者とみなされます。両方の競技者が同じ予選ラウンドの別々の組で競技をして、両者とも敗退した場合、タイムや順位にかかわらず、そのベットは無効になります。競技者が両者とも決勝に進んだ場合、決勝で順位が上だった方が勝者になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Auto-Racing" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          オートレーシング
        </h3>
        <ol>
          <li>
            <p>レースまたは予選が何らかの理由で遅れ、遅延が48時間を超える場合は、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p>レース開始は、ウォームアップラップ開始の合図とされています。</p>
          </li>
          <li>
            <p>レースマッチベッティング - ベットは表彰台の発表時の結果に基づく公式等級分けで確定となります。</p>
          </li>
        </ol>
        <p id="Auto-Racing-Market-Rules" style="font-weight: bold;">
          オートレーシングのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>予選：</strong>競技者が予選をスタートすると、その競技者に対するすべての予選ベットはアクションになります。その後に発生した違反や降格により、ベットの結果が影響を受けることはありません。競技者が予選をスタートしない場合、その競技者の予選または予選ポジションのベットは無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Handball" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ハンドボール
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、マッチピリオドのベットにオーバータイムは含まれません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Water-Polo" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          水球
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、すべてのベットは規定の時間のみを対象とし、オーバータイムおよびペナルティシュートアウトを含みません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Bandy" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          バンディ
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、すべてのマッチピリオドマーケットはレギュレーションタイムのみを対象とし、延長戦を含みません。</p>
          </li>
          <li>
            <p>試合の形式が、45分×2から30分×3に変更になった場合、マッチピリオドのベットはアクションになり、その他のピリオドのベットはすべて無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Hockey" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ホッケー
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、ゲームピリオドのベットにオーバータイムとペナルティシュートアウトが含まれます。</p>
          </li>
          <li>
            <p>オーバータイムを含むマーケットの場合、ペナルティシュートアウトはオーバータイムの一部とみなされます。ペナルティシュートアウトが行われる場合、勝利チームには<strong>1</strong>ゴールが与えられます。</p>
          </li>
          <li>
            <p>マッチマーケットへのベットでは、アクションとなるには55分以上プレイされる必要があります。55分間プレイする前に試合が中断された場合、プレイが完了したピリオドのベットはアクションになり、それ以外はすべて無効になります。</p>
          </li>
          <li>
            <p>NHLオールスターゲームのベットは、プレイされたピリオド数と各ピリオドでのプレイ時間に関係なくアクションになります。</p>
          </li>
        </ol>
        <p id="Hockey-Market-Rules" style="font-weight: bold;">
          ホッケーのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>競技者統計：</strong>データには延長戦(オーバータイム)が含まれますが、ペナルティシュートアウトは含まれません。対象の統計マーケットがアクションとなるには、指定競技者がレギュレーションタイムでプレイする必要があります。</p>
          </li>
          <li>
            <p><strong>レギュラシーズンポイント：</strong>チームが指定された合計ポイントを超え、かつ予定された試合をすべてプレイすることが見込まれる場合、または残された試合数を考慮すると合計ポイントを超えられそうになく、かつ予定された試合をすべてプレイすることが見込まれる場合に確定します。チームがフルシーズンをプレイするかどうかについて合理的な疑いがある場合は、シーズンポイントマーケットは、全試合をプレイするまで確定しません。シーズンポイントマーケットが確定した後は、チームが何らかの理由で予定よりも少ない試合しかプレイしなかった場合でも、変更されません。</p>
          </li>
          <li><strong>NHLイースタン・カンファレンスまたはウエスタン・カンファレンス勝利チーム：</strong>スタンレー・カップ決勝戦に進出したチームが、各カンファレンスの優勝チームとなります。</li>
          <li>
            <p><strong>枠内シュート：</strong>オーバータイム(延長戦)は含まれますが、ペナルティシュートアウトは含まれません。</p>
          </li>
          <li>
            <p><strong>NHL選手統計の確定：</strong>NHLでは試合終了直後に統計の見直しと修正が行われる場合があるため、午後11時00分(PT)頃まで待機した後に、公式のNHL統計に基づいて選手統計マーケットのすべてのコンテストを確定します。NHL選手統計マーケットはひとたび確定されると、それが最終的なものとなります。その後NHL統計でいかなる変更があろうと、それに合わせて修正されることはありません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Winter-Sports" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ウインタースポーツ
        </h3>
        <ol>
          <li>
            <p>競技が本来の開始時刻の48時間以内に完了しなかった場合、その競技のベットはすべて無効とみなされます。競技の短縮または延期が本来の開始時刻の48時間以内に公式に宣言された場合、ベットはアクションとなり、公式結果を使用してすべてのマーケットが確定されます。</p>
          </li>
          <li>
            <p>ベットがアクションとなるには、両選手がスタートライン/ゲートを離れる必要があります。</p>
          </li>
          <li>
            <p>競技が1ラウンドのみで構成されている場合、決済はそのラウンドの公式結果に基づいて行われます。</p>
          </li>
          <li>
            <p>複数ラウンドで構成されている競技については、両選手が後続ラウンドへの出場資格を獲得できなかった場合、決済は公式の認定または第1ラウンド/ランの順位に基づいて行われます。</p>
          </li>
          <ol type="a">
            <li>
              <p><strong>アルペンスキー</strong>の場合、少なくとも1人の競技者が競技全体を完了する必要があり、そうでない場合はベットは無効となります。</p>
            </li>
            <li>
              <p><strong>スキージャンプ</strong>の場合、行われたジャンプの回数や完了したラウンドの数に関係なく、公式結果が採用されます。</p>
            </li>
          </ol>
          <li>
            <p>競技を完了しなかった、または第1ラウンド/ラン中に失格になり、両選手ともに公式の第1ラウンド/ラン順位表に結果を登録できなかった場合、ベットは無効になります。</p>
          </li>
          <li>
            <p>両選手ともに後続ラウンドへの出場権を獲得したものの、どちらも競技を完了しなかった場合、ベットは無効になります。</p>
          </li>
          <ol type="a">
            <li>
              <p><strong>クロスカントリースキースプリント種目</strong>競技のマッチアップでは、競技の最終的な公式順位に基づいて決済が行われます。</p>
            </li>
          </ol>
          <li>
            <p>競技の開始後で、第1ラウンドが完了する前、または両選手が後続ラウンドへの出場資格を獲得した後に一方の選手が失格となった、もしくは棄権した場合、それぞれのラウンドを完了したものとして、もう一方の選手が勝者とみなされます。</p>
          </li>
          <li>
            <p>選手が後続ラウンド中に失格となった際に、マッチアップの相手選手がそのラウンドへの出場資格をまだ得ていなかった場合、失格した選手が勝者とみなされます。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Olympics" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          オリンピック
        </h3>
        <ol>
          <li>
            <p>メダルの授与式が終わると、結果は正式なものとみなされます。何らかの理由で結果がその後変更されても、考慮されません。</p>
          </li>
        </ol>
        <p id="Olympics-Market-Rules" style="font-weight: bold;">
          オリンピックのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>個人のメダルトータルマーケット：</strong>個人選手が参加が予定されている最初の種目を開始しない場合、アクションになりません。</p>
          </li>
          <li>
            <p><strong>重量挙げ：</strong>競技者が誰も種目全体を完了しなかった場合、すべての競技者のベットは無効になります。</p>
          </li>
          <li>
            <p><strong>国別メダルトータルマーケット：</strong>これらのマーケットは、オリンピック大会の終了時に、公式のメダル獲得数表の結果により確定します。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Padel-Tennis" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          パデルテニス
        </h3>
        <ol>
          <li>
            <p>競技者が棄権または失格になると、マッチマネーラインマーケットのベットは、1セットが終了している場合はアクションになり、それ以外の場合は無効になります。その他のマーケットのベットは、棄権または失格の前にピリオドが終了までプレイされていた場合を除いて、無効になります。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Boxing" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ボクシングおよび総合格闘技
        </h3>
        <ol>
          <li>
            <p>最初のラウンドが開始されると、予定された継続時間または実際の継続時間にかかわらず、試合は公式であるとみなされます。</p>
          </li>
          <li>
            <p>予定されていたラウンド数が変更されても、マネーラインのベットはアクションとなります。トータルラウンドオーバー/アンダーマーケットは、新しくスケジュールされたラウンド数がベットされたトータルより多い場合のみ、アクションとなります。それ以外のトータルラウンドオーバー/アンダーのベットは無効になります。</p>
          </li>
          <li>
            <p>特に明記されていない限り、予定された日時の1週間以内に試合が行われない場合、無効になります。</p>
          </li>
          <li>
            <p>テクニカルドローの場合、すべてのフルファイトピリオドマーケットは無効です。試合の終了前に完了していたピリオドと最終決定されたマーケットは確定します。</p>
          </li>
          <li>
            <p>「ノーコンテスト」となった試合では、既に完了したピリオドと、既に最終決定されたマーケットを除いて、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p>会場が同じ国の別の場所に変更された場合、ベットはアクションとなります。会場が別の国に変更された場合は、その試合のすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>対戦で追加のラウンドまたは「サドンビクトリー」ラウンドがあった場合、それらのラウンドはすべての関連マーケットでカウントされます。</p>
          </li>
        </ol>
        <p id="Boxing-Market-Rules" style="font-weight: bold;">
          ボクシングのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>インサイドディスタンスマーケット</strong>：選択した選手がKO、TKO、DQ、またはテクニカル判定によって勝った場合は、「インサイドディスタンス」による勝者へのベットに勝利したことになります。</p>
          </li>
          <li>
            <p><strong>「KO」マーケット</strong>：選択した選手がKO、TKO、DQによって勝った場合、「KO」による勝者ベットに勝利したことになります。</p>
          </li>
          <li>
            <p><strong>ラウンドオーバー/アンダー</strong>：このマーケットでは、1ラウンドが完了したとみなされるのは、時間が半分以上経過し、かつ試合が継続している場合です。</p>
          </li>
        </ol>
        <p id="MMA-Market-Rules" style="font-weight: bold;">
          総合格闘技(MMA)のマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>ラウンドオーバー/アンダーマーケット</strong>：このマーケットでは、1ラウンドが完了したとみなされるのは、時間が半分以上経過し、かつ試合が継続している場合です。</p>
          </li>
          <li>
            <p><strong>インサイドディスタンスマーケット</strong>：選択した選手がKO、TKO、DQ、サブミッション、テクニカルサブミッション、テクニカル判定、その他の形式による中止で勝利した場合、「インサイドディスタンス」勝利者ベットに勝利したことになります。</p>
          </li>
          <li>
            <p><strong>「KO」マーケット</strong>：選択した選手がKO、TKO、またはコーナーストップにより勝った場合、「KO」による勝者ベットに勝利したことになります。MMAでは、サブミッションによる勝利はKOやTKOとはなりません。</p>
          </li>
          <li>
            <p><strong>勝利方法マーケット</strong>：選手の勝利方法のはい/いいえマーケットは、試合が引き分けで終わった場合、「いいえ」とみなされます。</p>
          </li>
          <li>
            <p><strong>ラウンドXで勝利のマーケット</strong>：試合がそのラウンドで終了した、または選手が次のラウンドのベルに応じなかった場合、試合はそのラウンドで終了したとみなされます。</p>
          </li>
          <li>
            <p><strong>判定勝ちマーケット</strong>：テクニカル判定は試合結果とみなされ、試合がテクニカル判定になった場合、該当する選手が判定勝ちになります。</p>
          </li>
          <li>
            <p><strong>試合結果の決定</strong>：全ラウンド終了前のテクニカル判定か、全ラウンド終了後の通常の判定かは問わず、試合結果が決定されたとみなされます。</p>
          </li>
          <li><strong>ハンディキャップベット：</strong>ファイターがKO、TKO、サブミッション、または反則によって勝利した場合、そのファイターに賭けたすべてのハンディキャップベットは的中（勝ち）として精算されます。試合が判定（ジャッジのスコアカード）にもつれ込んだ場合は、3人のジャッジのスコアを合算した結果に基づいてスプレッドの勝敗が決まります。例：すべてのジャッジが49-46でファイターAの勝利と採点し、ファイターAのスプレッドが-6.5であった場合、ファイターAのハンディキャップベットは的中となります。</li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Politics" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          政治
        </h3>
        <ol>
          <li>
            <p>すべての政治ベットは、現地の選挙委員会または同等の公的機関により宣言された公式結果を使用して決定されます。</p>
          </li>
          <li>
            <p>候補者が「発表しなければならない」という規定がある場合、その候補者が選挙に出馬するという公式な発表を行った場合にのみ、ベットはアクションになります。公式な発表を行わない場合、すべてのベットは無効になります。</p>
          </li>
          <li>
            <p>政治ベットがルール#1に従って確定されると、結果は最終とみなされ、他の状況(病気、死亡、訴訟など)に基づいて変更されることはありません。</p>
          </li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Esports-Rules" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          Eスポーツ
        </h3>
        <ol>
          <li>
            <p>試合が開始予定時刻から30時間以内に開始しない場合、その試合のすべてのベットは無効になります。</p>
          </li>
          <li>
            <p>試合の形式が変更された場合(マップやラウンドの数など)、情報がマーケットに伝えられた場合や、変更が特定のマーケットに影響しない(特定のマップやファーストブラッドのベットなど)場合を除いて、すべてのベットが無効になります。</p>
          </li>
          <li>
            <p>試合またはマップが以前の時点やラウンドに巻き戻された場合、以下のルールが適用されます。</p>
            <p>リメイク（Remake）<br>マップ開始時（00:00の時点、または第1ラウンド）に試合またはマップがリメイクされた場合、未決済の試合前ベットはリプレイに基づいて有効となります。リプレイ前にすでに完了していた試合前マーケットの精算は変更されません。無効とされた期間中、または無効とされたマップ中に行われたライブベットは、結果がすでに確定していない限り無効となります。それ以外のライブベットは有効となり、リメイクされた試合またはマップは別の試合として扱われます。</p>
            <p>リワインド（Rewind）<br>マップがマップ開始時（00:00の時点、または第1ラウンド）以外のタイミングに巻き戻された場合、未決済の試合前ベットはリプレイ後の最終スコアおよび統計に基づいて精算され、巻き戻しにより無効となった内容はカウントされません。リプレイ前に完了していた試合前マーケットの精算は変更されません。無効とされた期間中に行われたライブベットを含め、すべてのライブベットは有効とされます。</p>
          </li>
          <li>
            <p>一方のチーム/競技者が、大会形式の一部として(例えばダブルエリミネーション方式で、上位のブラケット/山を勝ち上がった1チームに対して)与えられる、1マップ以上のアドバンテージを有しているマッチでは、AP Gamingのマッチラインに特定のアドバンテージが含まれます。アドバンテージが1-0の場合、AP Gamingのマップの提供はマップ2から始まります。2-0の場合はマップ3から始まり、以下同様となります。そのアドバンテージが、例えば一方のチームが試合に遅刻した場合など、運営側の判断によって認められた不戦勝や棄権での勝利から生じている場合、このルールは適用されません。</p>
          </li>
          <li>
            <p>「キル」マーケットは、ゲームのサブスポーツルールで別途指示がない限り、公式放送、スコアボード、またはAPIを使用して結果を決定します。</p>
          </li>
          <li>
            <p>マッチピリオドハンディキャップ、マネーライン、およびオーバー/アンダーマーケットは、勝利したマップをスコアリング単位として使用します。</p>
          </li>
          <li>
            <p>延長戦またはその他のタイブレーカーシステムが導入された場合、結果を決定するうえで有効とみなされます。</p>
          </li>
          <li>
            <p>棄権、接続切断、失格、不戦勝、あるいはその他の運営側の判断によりマップが無効になった場合、マッチピリオドへのすべてのベットが無効になります。各マップへのベットは、マップの終了までプレイされれば有効になります。公式結果をもって終了したイベントは、交換要員のプレイヤーやスタンドインプレイヤーの数にかかわらず、アクションになります。</p>
          </li>
        </ol>
        <p style="font-weight: bold;">
          サブスポーツルール
        </p>
        <p id="CS2" style="font-weight: bold;">
          CS2
        </p>
        <ol>
          <li>
            <p>マップの4ラウンド以上が10人未満の競技者でプレイされた場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>マップで予定されていたすべてのラウンドがプレイされる前に、チームが棄権した、運営側の判断で勝ちとされた、または失格となった場合、そのマップへのベットはすべて無効になります。</p>
          </li>
          <li>
            <p>CS2マップは12ラウンドハーフです。</p>
          </li>
          <li>
            <p>いずれかのマップがCS:GOに切り替えられた場合、Max Rounds 12形式からthe Max Rounds 15形式への変更の影響を受ける試合およびマップのマーケットはすべて無効になります。</p>
          </li>
        </ol>
        <p id="Valorant" style="font-weight: bold;">
          ヴァロラント (Valorant)
        </p>
        <ol>
          <li>
            <p>マップの4ラウンド以上が10人未満の競技者でプレイされた場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>マップで予定されていたすべてのラウンドがプレイされる前に、チームが棄権した、運営側の判断で勝ちとされた、または失格となった場合、そのマップへのベットはすべて無効になります。</p>
          </li>
          <li>
            <p>ヴァロラントマップは12ラウンドハーフです。</p>
          </li>
        </ol>
        <p id="Dota2" style="font-weight: bold;">
          Dota 2
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットが無効になり、<strong>マップは無効とみなされます</strong>。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>Dota 2のキル：Dota 2では以下をキルとしてカウントします。</p>
            <p>- プレイヤーのキル</p>
            <p>- 相手チームのタワーのキル</p>
            <p>- 相手チームのクリープのキル</p>
            <p>Dota 2では以下をキルとしてカウントしません。</p>
            <p>- チームメイトのディナイ</p>
            <p>- 自分のヒーローのディナイ</p>
            <p>- 中立クリープによるデス</p>
            <p>- Roshanによるデス</p>
          </li>
        </ol>
        <p id="King-of-Glory" style="font-weight: bold;">
          王者栄耀
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
        </ol>
        <p id="Arena-of-Valor" style="font-weight: bold;">
          Arena of Valor
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
        </ol>
        <p id="Heroes-of-the-Storm" style="font-weight: bold;">
          Heroes of the Storm
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
        </ol>
        <p id="League-of-Legends" style="font-weight: bold;">
          リーグ・オブ・レジェンド (League of Legends)
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
          <li>
            <p>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</p>
          </li>
          <li>
            <p>「エレメンタルドラゴン」に含まれるドラゴンは、クラウド、マウンテン、インファーナル、オーシャン、ケミテック、へクステックのみです。</p>
          </li>
        </ol>
        <p id="Overwatch" style="font-weight: bold;">
          Overwatch
        </p>
        <ol>
          <li>
            <p>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</p>
          </li>
        </ol>
        <p id="Rainbow-Six" style="font-weight: bold;">
          レインボーシックス
        </p>
        <ol>
          <li>
            <p>マップで予定されていたすべてのラウンドが完了する前に、チームが棄権した、運営側の判断で勝ちとされた、または失格になった場合、そのマップへのベットはすべて無効になります。</p>
          </li>
        </ol>
        <p id="Fortnite" style="font-weight: bold;">
          Fortnite
        </p>
        <ol>
          <li>
            <p>順位は、可能な限り、公式のトーナメントランキングに従って決定されます。トーナメントが最終結果を明確に示さない場合、次の計算式が使用されます。個別ラウンドのベットは、一番長く残ったチームまたは競技者に基づいて決定されます。プレイ日のベットは、対象となるチームまたは競技者がその日に獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。また、イベント勝者のベットは、各チームがイベントを通して獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。</p>
          </li>
        </ol>
        <p id="PUBG" style="font-weight: bold;">
          PUBG
        </p>
        <ol>
          <li>
            <p>順位は、可能な限り、公式のトーナメントランキングに従って決定されます。トーナメントが最終結果を明確に示さない場合、次の計算式が使用されます。個別ラウンドのベットは、一番長く残ったチームまたは競技者に基づいて決定されます。プレイ日のベットは、対象となるチームまたは競技者がその日に獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。また、イベント勝者のベットは、各チームがイベントを通して獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。</p>
          </li>
        </ol>
        <p id="Free-Fire" style="font-weight: bold;">
          Free Fire
        </p>
        <ol>
          <li>
            <p>順位は、可能な限り、公式のトーナメントランキングに従って決定されます。トーナメントが最終結果を明確に示さない場合、次の計算式が使用されます。個別ラウンドのベットは、一番長く残ったチームまたは競技者に基づいて決定されます。プレイ日のベットは、対象となるチームまたは競技者がその日に獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。また、イベント勝者のベットは、各チームがイベントを通して獲得したトータルポイント(順位ポイント+キルポイント)に基づいて決定されます。</p>
          </li>
        </ol>
        <p id="Mobile Legend" style="font-weight: bold;">
          モバイルレジェンド
        </p>
        <ol>
          <li>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</li>
          <li>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</li>
          <li>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</li>
        </ol>
        <p id="Wild Rift" style="font-weight: bold;">
          ワイルドリフト
        </p>
        <ol>
          <li>マップが10人未満の競技者で開始された場合、そのマップのすべてのベットが無効になります。</li>
          <li>最初の10分間で競技者の接続が切断され、再接続ができない、またはマップの残りで交代できない場合、そのマップのすべてのベットは無効になります。競技者がマップでのプレイ開始10分以降に接続が切断された、または終了した場合、ベットは公式結果に従ってアクションになります。</li>
          <li>マップの最初の10分で運営側の判断により不戦勝または勝ちと判定された場合、そのマップへのベットはすべて無効になります。マップでのプレイ開始10分以降に運営側の判断により勝ちと判定された場合、ベットは公式結果に従ってアクションになります。</li>
        </ol>
        <p id="Esports-Market-Rules" style="font-weight: bold;">
          Eスポーツのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>マップ継続時間オーバー/アンダー：</strong>合計の継続時間(分単位)がベットの対象となります。アンダーのベットは、マップがその分数よりも早く終了すれば勝利となり、オーバーのベットは、マップがその分数より長く続くと勝利となります。公式放送、スコアボード、またはAPIに表示された時間通り(秒単位まで。例：15分のオーバー/アンダーラインで15:00)にマップが終了した場合、ベットは無効になります。</p>
          </li>
          <li>
            <p><strong>ファーストタワー</strong>：最初にタワーを破壊されたチームへのベットは負けとなり、相手チームへのベットが勝ちとなります。</p>
          </li>
          <li>
            <p><strong>ファーストブラッド</strong>：スコアボードで勝利と表示される、ファーストキルを獲得した最初のチームへのベット、およびその他の負けたチームへのベット。</p>
          </li>
          <li>
            <p><strong>ファーストインヒビター</strong>：最初にインヒビターのいずれかが破壊されたチームへのベットは負けとなり、相手チームへのベットが勝ちとなります。</p>
          </li>
          <li>
            <p><strong>ファーストバラック</strong>：最初にバラックのいずれかが破壊されたチームへのベットは負けとなり、相手チームへのベットが勝ちとなります。</p>
          </li>
          <li>
            <p><strong>ファーストタレット：</strong>最初にタレットのいずれかが破壊されたチームへのベットは負けとなり、相手チームへのベットが勝ちとなります。</p>
          </li>
          <li>
            <p><strong>エースはいるか：</strong>エースとは、1ラウンドで5人の敵を倒す1人のプレイヤーとして定義されています。</p>
          </li>
          <li>
            <p><strong>ナイフキルはあるか：</strong>ナイフキルとは、オフィシャルラウンドで1人のプレイヤーがナイフで敵1人を倒すこととして定義されています。</p>
          </li>
          <li>
            <p><strong>先に進む： </strong>チームの「先に進む」または「決勝で勝利」のマーケットは、どのチームが次のラウンドに進む、またはトーナメントで優勝するかについてのベットです。試合またはステージが完了すると、移動、遅延、または延期されたかにかかわらず、いつでもどこでもベットはアクションとなります。</p>
          </li>
          <li>
            <p><strong>合計マップマーケット: </strong>タイマップは合計マップマーケットではカウントされません。</p>
          </li>
          <li><strong>破壊されたタレットの合計数：</strong>ネクスタレットは、マップ内で最初に破壊されたときのみ精算対象としてカウントされます。リスポーン後に再度破壊された場合は、たとえ中継のスコアボードに含まれていたとしても、精算対象にはなりません。</li>
        </ol>
      </div>

      <div style="background: #f3f3f3; padding: 15px; margin-bottom: 15px;">
        <h3 id="Poker" style="text-transform: uppercase; font-weight: bold; font-size: 1.1rem;">
          ポーカー
        </h3>
        <ol>
          <li>
            <p>特に明記されていない限り、オープンエントリーのイベントのみがブレスレットイベントとみなされます。</p>
          </li>
          <li>
            <p>「セッション」は、1日のポーカーを意味し、その日どれくらいの時間プレイしたかは関係なく、深夜をまたいで翌日になった場合も有効です。</p>
          </li>
        </ol>
        <p id="Poker-Market-Rules" style="font-weight: bold;">
          ポーカーのマーケットルール
        </p>
        <ol>
          <li>
            <p><strong>マッチアップ：</strong>アクションになるには、両競技者がテーブルに着き、イベント中少なくとも1回ハンドをプレイする必要があります。獲得金額がより上位で終了した競技者が勝者とみなされます。双方の競技者が資金不足で終了した場合、より多くのセッションでプレイした競技者が勝者とみなされます。双方の競技者が同じ数のセッションをプレイして資金不足で終了した場合、ベットは無効です。</p>
          </li>
        </ol>
      </div>
    </section>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'

export default {
  components: {
    goToTop
  },
  data() {
    return {
      content: false
    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>

<style scoped>
#ap-sports-rules {
  width: 100%;
  max-width: none;
  padding: 0 50px 40px;
  padding: 0 clamp(16px, 3.5vw, 50px) 40px;
  }

  #ap-sports-rules,
  #ap-sports-rules p,
  #ap-sports-rules li,
  #ap-sports-rules td,
  #ap-sports-rules a {
  font-size: 1rem;
  line-height: 1.8;
  }

  #ap-sports-rules > div[style*="background:#fff8e5"] {
  width: 100%;
  }

  #ap-sports-rule-index {
  width: 100%;
  }

  #ap-sports-rule-index > div {
  width: 100%;
  }

  #ap-sports-rules table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  margin: 16px 0 28px;
  }

  #ap-sports-rules table td {
  vertical-align: middle;
  word-break: keep-all;
  overflow-wrap: anywhere;
  }

  #ap-sports-rules table td[colspan] p {
  text-align: center;
  }

  @media (max-width: 768px) {
  #ap-sports-rules {
  padding: 0 12px 32px;
  }

  #ap-sports-rules,
  #ap-sports-rules p,
  #ap-sports-rules li,
  #ap-sports-rules td,
  #ap-sports-rules a {
  font-size: 0.95rem;
  line-height: 1.75;
  }

  #ap-sports-rules table {
  display: block;
  width: 100% !important;
  overflow-x: auto;
  table-layout: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  }

  #ap-sports-rules table tbody {
  display: table;
  width: max-content;
  min-width: 100%;
  }

  #ap-sports-rules table td {
  overflow-wrap: normal;
  word-break: normal;
  }
  }
</style>
